/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.






/* =========================
   FOZOCO • Drawer PRO (Lentes) — v1.1 (atualizado)
   - Habilita apenas em produtos (óculos) com tag: HABILITA_LENTES
   - Substitui o botão principal por “Escolher lentes e comprar”
   - Fluxo: com grau (leve/moderado) ou sem grau
   - Receita: upload agora (RECEITA_OK) ou enviar via WhatsApp (RECEITA_PENDENTE)
   - Adiciona óculos + lente escolhida ao carrinho e abre o UpCart
   ========================= */

(() => {
  const TAG_HABILITA = "HABILITA_LENTES";

  /* Trava mestra do fluxo de lentes. So vira true depois que
     productHasTag(TAG_HABILITA) confirmar a tag no onReady la embaixo.
     Existe porque o re-bind por MutationObserver (procure por
     __fozoco_cta_rebind) roda no escopo do modulo, ou seja, em TODA pagina
     de produto, e chamava setupCTA() sem checar a tag — abrindo o drawer
     de grau em oculos de sol. */
  let __fozocoLentesEnabled = false;
  const VARIANT_ID_LEVE = 47358532911339;      // Grau Leve (atualizado)
  const VARIANT_ID_MODERADO = 47358533697771;  // Grau Moderado
  const VARIANT_ID_ALTO = 48895106711787;      // Grau Alto

  // Copys/flags vindos do Theme Settings (theme.liquid)
  const COPY = (window.FOZOCO_LENTES_COPY || {});
  const FLAGS = (window.FOZOCO_LENTES_FLAGS || {});

  const copy = (key, fallback) => {
    const v = COPY && Object.prototype.hasOwnProperty.call(COPY, key) ? COPY[key] : undefined;
    if (typeof v === "string" && v.trim()) return v.trim();
    return fallback;
  };

  // Retorna string do Theme Settings ou null (sem fallback)
  const getCopy = (key) => {
    const v = COPY && Object.prototype.hasOwnProperty.call(COPY, key) ? COPY[key] : undefined;
    if (typeof v === "string" && v.trim()) return v.trim();
    return null;
  };

  // =========================
  // Preços dos graus (Passo 2)
  // - Se o cliente preencher no Theme Settings, usa esse valor (grau_leve_price / grau_moderado_price)
  // - Caso contrário, tenta buscar o preço real do variant no Shopify (/variants/<id>.js)
  // =========================
  const _priceCache = new Map();
  const _priceInflight = new Map();

  const formatBRLFromCents = (cents) => {
    const n = Number(cents);
    if (!Number.isFinite(n)) return null;
    // Shopify retorna em centavos
    const v = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(n / 100);
    return v.replace(/\u00A0/g, " ");
  };

  const fetchVariantPriceLabel = async (variantId) => {
    if (_priceCache.has(variantId)) return _priceCache.get(variantId);
    if (_priceInflight.has(variantId)) return _priceInflight.get(variantId);

    const p = fetch(`/variants/${variantId}.js`, { credentials: "same-origin" })
      .then((r) => (r.ok ? r.json() : null))
      .then((v) => {
        const label = v && v.price != null ? formatBRLFromCents(v.price) : null;
        if (label) _priceCache.set(variantId, label);
        return label;
      })
      .catch(() => null)
      .finally(() => _priceInflight.delete(variantId));

    _priceInflight.set(variantId, p);
    return p;
  };

  const setPriceEl = (el, overrideLabel, variantId) => {
    if (!el) return;

    // 1) Override via theme settings
    if (overrideLabel) {
      el.textContent = overrideLabel;
      return;
    }

    // 2) Cache
    const cached = _priceCache.get(variantId);
    if (cached) {
      el.textContent = cached;
      return;
    }

    // 3) Busca async
    el.textContent = "…";
    fetchVariantPriceLabel(variantId).then((label) => {
      if (!label) return;
      if (document.contains(el)) el.textContent = label;
    });
  };

  function hydrateGrauPrices(rootEl) {
    const leveEl = rootEl.querySelector('[data-lente-price="LENTE_GRAU_LEVE"]');
    const modEl  = rootEl.querySelector('[data-lente-price="LENTE_GRAU_MODERADO"]');
    const altoEl = rootEl.querySelector('[data-lente-price="LENTE_GRAU_ALTO"]');

    setPriceEl(leveEl, getCopy("grau_leve_price"), VARIANT_ID_LEVE);
    setPriceEl(modEl,  getCopy("grau_moderado_price"), VARIANT_ID_MODERADO);
    setPriceEl(altoEl, getCopy("grau_alto_price"), VARIANT_ID_ALTO);
  }


  const escapeHtml = (s) =>
    String(s ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  // WhatsApp da loja (formato: DDI + DDD + número, apenas dígitos)
  // Ex.: +55 43 99168-8285 => "5543991688285"
  const WHATSAPP_PHONE = "5543991688285";

  // Mensagem padrão (não aparece na tela; usada apenas no link salvo no pedido)
  const WHATSAPP_MESSAGE = "Olá! Finalizei minha compra de óculos com grau na FOZOCO e estou enviando minha receita.";

  function buildWhatsAppUrlFull() {
    const phone = String(WHATSAPP_PHONE || "").replace(/\D/g, "");
    if (!phone) return "";
    return `https://wa.me/${phone}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
  }

  function buildWhatsAppUrlShort() {
    const phone = String(WHATSAPP_PHONE || "").replace(/\D/g, "");
    if (!phone) return "";
    return `https://wa.me/${phone}`;
  }

  function fixCartCheckoutText() {
    // Apenas na página de carrinho (/cart)
    if (!/^\/cart(\/|$)/.test(window.location.pathname || "")) return;

    const label = "Finalizar compra";
    const selectors = [
      'button[name="checkout"]',
      'button[type="submit"][name="checkout"]',
      'input[name="checkout"]',
      '[data-cart-submit] button',
      '.cart__checkout button',
      '.cart__checkout-button',
      '#checkout',
    ];

    const seen = new Set();
    for (const sel of selectors) {
      const el = document.querySelector(sel);
      if (!el || seen.has(el)) continue;
      seen.add(el);

      if (el.getAttribute("data-lentes-fixed") === "1") continue;

      // INPUT submit
      if (el.tagName === "INPUT") {
        const v = (el.value || "").trim();
        if (!v) el.value = label;
        el.setAttribute("data-lentes-fixed", "1");
        return;
      }

      // Preferir preencher um span interno, se existir
      const span = el.querySelector("span");
      const spanText = span ? (span.textContent || "").trim() : "";
      const btnText = (el.textContent || "").trim();

      if (span && !spanText) {
        span.textContent = label;
        el.setAttribute("data-lentes-fixed", "1");
        return;
      }

      if (!btnText) {
        el.textContent = label;
        el.setAttribute("data-lentes-fixed", "1");
        return;
      }
    }
  }



  // Tags dos produtos de lente (para facilitar manutenção no futuro)
  const LENTES_COLLECTION_HANDLE = "lentes"; // ajuste para o handle da coleção que contém as lentes
  const TAG_LENTE_LEVE = "LENTE_GRAU_LEVE";
  const TAG_LENTE_MODERADO = "LENTE_GRAU_MODERADO";
  const TAG_LENTE_ALTO = "LENTE_GRAU_ALTO";

// Integração com App de Upload (ex.: Upload-Lift)
// O app normalmente injeta inputs `properties[...]` dentro do form do produto.
// Como este script adiciona ao carrinho via AJAX, precisamos capturar essas propriedades e enviar junto.
function getMainProductForm() {
  return (
    document.querySelector('form[action^="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]')
  );
}

function hideInternalCartProperties(scope) {
  // ⚠️ Importante: esconder apenas as LINHAS de propriedades internas.
  // Nunca esconder containers grandes (ex.: o próprio drawer), senão o carrinho "abre" mas fica invisível e trava a página.
  const root = scope || document;

  // Só varre elementos pequenos/folha (sem filhos), onde normalmente ficam as propriedades.
  const nodes = root.querySelectorAll("li, p, dd, dt, span, small, em, strong");
  nodes.forEach((el) => {
    try {
      if (!el) return;
      if (el.children && el.children.length) return; // evita containers

      const t = (el.textContent || "").trim();
      if (!t) return;

      const tl = t.toLowerCase();

      const isInternal =
        tl.startsWith("_whatsapp_link") || tl.includes("_whatsapp_link:") ||
        tl.startsWith("_fozoco_") || tl.includes("_fozoco_") ||
        tl.startsWith("_fozoco_bundle") || tl.includes("_fozoco_bundle");

      // backup sem "_" (esconde também)
      const isInternal2 = tl.startsWith("fozoco_bundle") || tl.includes("fozoco_bundle");

      const internal = isInternal || isInternal2;

      if (!internal) return;

      const row =
        el.closest("li") ||
        el.closest("dd") ||
        el.closest("dt") ||
        el.closest("p") ||
        el;

      if (!row || !row.style) return;
      if (row.dataset && row.dataset.fozocoHiddenProp === "1") return;
      if (row.dataset) row.dataset.fozocoHiddenProp = "1";

      row.style.display = "none";
    } catch (_) {}
  });
}






// ✅ Limita as propriedades exibidas no carrinho/drawer.
// O cliente quer ver apenas:
// - Lente escolhida
// - Envio da receita
// - Receita status
// Todo o resto (ex.: "Cor", campos do app de upload, etc.) fica oculto na UI.
const __FOZOCO_CART_PROP_ALLOWLIST = ["lente escolhida", "envio da receita", "receita status"];


function hideCartPropertiesExceptAllowed(scope) {
  const root = scope || document;
  const allow = __FOZOCO_CART_PROP_ALLOWLIST;

  const isAllowedKey = (k) => allow.includes(String(k || "").trim().toLowerCase());

  const inCartUi = (el) => {
    try {
      if (!el || !el.closest) return false;
      return !!el.closest(
        '#CartDrawer, .cart-drawer, [data-cart-drawer], .drawer--cart, [data-upcart], #upcart, .upcart'
      );
    } catch (_) { return false; }
  };

  const inCartItem = (el) => {
    try {
      if (!el || !el.closest) return false;
      return !!el.closest(
        '[data-line-item], [data-cart-item], .cart__item, .cart-item, .line-item, .upcart-item, [class*="upcart-item"], [class*="CartItem"], [class*="lineItem"]'
      );
    } catch (_) { return false; }
  };

  const escapeHtml = (s) =>
    String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const lineKeyFromText = (line) => {
    const m = String(line || "").match(/^([^:]{2,80}):/);
    return m ? (m[1] || "").trim() : "";
  };

  const keepOnlyAllowedLinesInBlock = (el) => {
    try {
      if (!el || !el.innerHTML || !el.style) return false;
      if (!inCartUi(el) || !inCartItem(el)) return false;
      if (el.dataset && el.dataset.fozocoScrubbed === "1") return true;

      const rawText = (el.textContent || "").trim();
      if (!rawText) return false;

      // Só mexe em blocos "meta" (não mexer em containers grandes)
      if (rawText.length > 500) return false;

      const hasBr = /<br\s*\/?>/i.test(el.innerHTML);
      const hasNewlines = /\n/.test(rawText);
      const hasInternalMarkers = /(^|\s)(_fozoco_|fozoco_bundle|_whatsapp_link)/i.test(rawText);
      const hasAnyAllowed = allow.some((k) => rawText.toLowerCase().includes(k + ":"));

      // Se for um bloco com várias linhas OU contém marcadores internos, a gente filtra as linhas
      if (!hasBr && !hasNewlines && !hasInternalMarkers && !hasAnyAllowed) return false;

      const lines = rawText
        .split(/\n+/)
        .map((x) => String(x || "").trim())
        .filter(Boolean);

      if (!lines.length) return false;

      const kept = [];
      for (const ln of lines) {
        const key = lineKeyFromText(ln).toLowerCase();
        if (key && isAllowedKey(key)) kept.push(ln);
      }

      // Se não tiver nenhuma linha permitida e o bloco for claramente de properties internas → esconde o bloco
      if (!kept.length && (hasInternalMarkers || /:/.test(rawText))) {
        if (el.dataset) el.dataset.fozocoHiddenProp = "1";
        el.style.display = "none";
        if (el.dataset) el.dataset.fozocoScrubbed = "1";
        return true;
      }

      // Se tem linhas permitidas, reescreve só com elas
      if (kept.length) {
        el.innerHTML = kept.map(escapeHtml).join("<br>");
        if (el.dataset) el.dataset.fozocoScrubbed = "1";
        return true;
      }

      return false;
    } catch (_) {
      return false;
    }
  };

  // 0) Primeiro: filtra blocos grandes de meta (muito comum em drawers/apps)
  try {
    root.querySelectorAll("small, p, div, span").forEach((el) => {
      try { keepOnlyAllowedLinesInBlock(el); } catch (_) {}
    });
  } catch (_) {}

  // 1) Formato clássico: dt/dd (mantém apenas as chaves permitidas)
  try {
    root.querySelectorAll("dt").forEach((dt) => {
      try {
        if (!dt || !dt.style) return;
        if (!inCartUi(dt) || !inCartItem(dt)) return;

        const key = (dt.textContent || "").trim().replace(/:$/, "");
        if (!key) return;

        if (isAllowedKey(key)) return;

        if (dt.dataset) dt.dataset.fozocoHiddenProp = "1";
        dt.style.display = "none";

        const dd = dt.nextElementSibling;
        if (dd && dd.tagName && dd.tagName.toLowerCase() === "dd" && dd.style) {
          if (dd.dataset) dd.dataset.fozocoHiddenProp = "1";
          dd.style.display = "none";
        }
      } catch (_) {}
    });
  } catch (_) {}

  // 2) Linhas "Chave: Valor" em nós pequenos – mesmo que tenham <br> ou spans internos
  try {
    const nodes = root.querySelectorAll("li, p, span, small, em, strong, div");
    nodes.forEach((el) => {
      try {
        if (!el || !el.style) return;
        if (!inCartUi(el) || !inCartItem(el)) return;

        const t = (el.textContent || "").trim();
        if (!t) return;

        // evita esconder coisas de preço
        if (/\bR\$\s*\d/.test(t) || /\bsubtotal\b/i.test(t) || /\btotal\b/i.test(t)) return;

        // Se for um bloco multi-linha, já tentamos filtrar acima
        if (el.dataset && el.dataset.fozocoScrubbed === "1") return;

        // Pega a primeira chave detectável
        const lines = t.split(/\n+/).map((x) => String(x || "").trim()).filter(Boolean);
        if (!lines.length) return;

        // Se qualquer linha não permitida existir e o elemento parece ser uma linha de props, escondemos a linha inteira
        // Mas apenas se tiver pelo menos 1 chave no formato "X: Y"
        let foundKey = false;
        let shouldHide = false;

        for (const ln of lines) {
          const k = lineKeyFromText(ln);
          if (!k) continue;
          foundKey = true;
          if (!isAllowedKey(k)) {
            shouldHide = true;
            break;
          }
        }

        if (!foundKey) return;

        // Se tem linhas permitidas e não permitidas no mesmo elemento, reescreve apenas as permitidas
        if (foundKey && !shouldHide) return;

        const kept = [];
        for (const ln of lines) {
          const k = lineKeyFromText(ln).toLowerCase();
          if (k && isAllowedKey(k)) kept.push(ln);
        }

        const row = el.closest("li") || el.closest("p") || el;
        if (!row || !row.style) return;

        if (kept.length) {
          row.innerHTML = kept.map(escapeHtml).join("<br>");
          if (row.dataset) row.dataset.fozocoScrubbed = "1";
          return;
        }

        if (row.dataset && row.dataset.fozocoHiddenProp === "1") return;
        if (row.dataset) row.dataset.fozocoHiddenProp = "1";
        row.style.display = "none";
      } catch (_) {}
    });
  } catch (_) {}
}


function startCartUiObserver() {
  if (window.__fozoco_cart_ui_observer) return;
  window.__fozoco_cart_ui_observer = true;

  let scheduled = false;
  let lastRun = 0;

  const run = () => {
    try {
      lastRun = Date.now();

      // Só roda se estiver em /cart ou se existir UI de carrinho (drawer/mini-cart)
      const onCartPage = /^\/cart(\/|$)/.test(window.location.pathname || "");
      const cartRoot = onCartPage
        ? (document.querySelector('form[action="/cart"]') || document.querySelector('main') || document)
        : document.querySelector(CART_UI_SELECTOR);
      if (!cartRoot) return;

      try { fixCartCheckoutText(); } catch (_) {}

      // Esconde props internas APENAS dentro do carrinho (página /cart ou drawer)
      try { hideInternalCartProperties(cartRoot); } catch (_) {}

      // Esconde propriedades que o cliente não quer ver (mantém só as 3 chaves permitidas)
      try { hideCartPropertiesExceptAllowed(cartRoot); } catch (_) {}

      // Garante que o drawer do carrinho não fique "morto"
      try { restoreCartUiPointerEvents(); } catch (_) {}
    } catch (_) {}
  };

  const schedule = (delay = 180) => {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => {
      scheduled = false;
      // Evita loop em cascata (se várias mutações acontecerem)
      if (Date.now() - lastRun < 120) return;
      run();
    }, delay);
  };

  // roda já uma vez (bem leve)
  run();

  // Observa APENAS inserções/remoções no DOM (childList). Não observa "class" nem "style",
  // porque isso dispara o tempo todo e deixa a página lenta.
  try {
    const obs = new MutationObserver(() => schedule(220));
    obs.observe(document.body, { subtree: true, childList: true });
  } catch (_) {}

  // Eventos do tema: carrinho mudou -> reprocessa (leve)
  try { document.addEventListener("theme:cart:change", () => schedule(120), true); } catch (_) {}
  try { document.addEventListener("theme:cart:open", () => schedule(120), true); } catch (_) {}
  try { document.addEventListener("cart:open", () => schedule(120), true); } catch (_) {}
  try { document.addEventListener("ajaxCart:open", () => schedule(120), true); } catch (_) {}
}



function collectLineItemProperties(root) {
  const out = {};
  if (!root) return out;

  const fields = root.querySelectorAll(
    'input[name^="properties["], textarea[name^="properties["], select[name^="properties["]'
  );

  fields.forEach((el) => {
    if (!el || el.disabled) return;

    // Não enviar `type=file` via /cart/add.js (Shopify não armazena arquivo bruto)
    if (el.tagName === "INPUT" && el.type === "file") return;

    const raw = (el.value ?? "").toString();
    const val = raw.trim();
    if (!val) return;

    const match = el.name.match(/^properties\[(.+)\]$/);
    const key = match ? match[1] : el.name.replace(/^properties\[/, "").replace(/\]$/, "");
    out[key] = val;
  });

  return out;
}

function isLikelyUploadPropKey(key) {
  const k = String(key || "").toLowerCase();
  return (
    k.includes("receita") ||
    k.includes("upload") ||
    k.includes("arquivo") ||
    k.includes("file") ||
    k.includes("prescri")
  );
}

function hasUploadAppValue(props) {
  const entries = Object.entries(props || {});
  if (!entries.length) return false;

  const likely = entries.filter(([k, v]) => isLikelyUploadPropKey(k) && String(v || "").trim());
  if (likely.length) return true;

  // fallback: qualquer propriedade não vazia
  return entries.some(([, v]) => String(v || "").trim());
}



function getUploadAppProperties() {
  const root = _uploadAppRoot || findUploadAppRoot() || getMainProductForm();
  return collectLineItemProperties(root);
}

// ✅ Captura arquivo selecionado no app (input[type=file]) para permitir "Anexo" via AJAX (/cart/add.js)
function getUploadAppSelectedFile() {
  try {
    // Prioriza o input do drawer (quando existe), mesmo que haja app de upload no DOM
    const drawerInput = document.getElementById("lentes-file");
    if (drawerInput && drawerInput.files && drawerInput.files.length) {
      return drawerInput.files[0] || null;
    }
    const root = _uploadAppRoot || findUploadAppRoot() || getMainProductForm() || document;
    if (!root || !root.querySelector) return null;

    const input =
      root.querySelector('input[type="file"][name^="properties["]') ||
      root.querySelector('input[type="file"]');

    if (!input || !input.files || !input.files.length) return null;
    return input.files[0] || null;
  } catch (_) {
    return null;
  }
}

function isAllowedRecipeFile(file) {
  if (!file) return false;
  const type = String(file.type || "").toLowerCase();
  const name = String(file.name || "").toLowerCase();
  if (type.startsWith("image/")) return true;
  if (type === "application/pdf") return true;
  return /\.(pdf|png|jpe?g|webp|heic|heif)$/i.test(name);
}

function findUploadAppRoot() {
  const form = getMainProductForm();
  const scope = form || document;

  // Prioriza app blocks do Shopify (OS 2.0)
  const blocks = Array.from(
    scope.querySelectorAll(".shopify-app-block, [data-shopify-app-block], .shopify-block")
  );

  for (const b of blocks) {
    const hasProps = b.querySelector('[name^="properties["]');
    if (!hasProps) continue;

    const hasFile = b.querySelector('input[type="file"]');
    const txt = (b.textContent || "").toLowerCase();
    if (hasFile || txt.includes("receita") || txt.includes("upload") || txt.includes("arquivo")) {
      return b;
    }
  }

  // Fallback: container próximo do primeiro input properties[...]
  const anyProp = scope.querySelector('[name^="properties["]');
  const fileInput =
    scope.querySelector('form[action*="/cart/add"] input[type="file"]') ||
    scope.querySelector('input[type="file"]');

  if (!anyProp && !fileInput) return null;

  const anchor = anyProp || fileInput;

  return (
    anchor.closest(".shopify-app-block") ||
    anchor.closest("[data-shopify-app-block]") ||
    anchor.closest(".shopify-block") ||
    anchor.closest(".upload-lift") ||
    anchor.closest('[class*="upload-lift"]') ||
    anchor.parentElement
  );
}

let _uploadAppRoot = null;
let _uploadAppOriginalParent = null;
let _uploadAppOriginalNext = null;
let _uploadWatchTimer = null;

function mountUploadAppInto(slotEl) {
  if (!slotEl) return false;

  const root = _uploadAppRoot || findUploadAppRoot();
  if (!root || !root.parentNode) {
      return false;
    }

  if (!_uploadAppOriginalParent) {
    _uploadAppRoot = root;
    _uploadAppOriginalParent = root.parentNode;
    _uploadAppOriginalNext = root.nextSibling;
  }

  if (!slotEl.contains(root)) {
    slotEl.appendChild(root);
  }
  return true;
}

function restoreUploadApp() {
  if (!_uploadAppRoot || !_uploadAppOriginalParent) return;

  const parent = _uploadAppOriginalParent;
  const next = _uploadAppOriginalNext;

  if (next && next.parentNode === parent) parent.insertBefore(_uploadAppRoot, next);
  else parent.appendChild(_uploadAppRoot);
}

function clearUploadWatch() {
  if (_uploadWatchTimer) {
    clearInterval(_uploadWatchTimer);
    _uploadWatchTimer = null;
  }
}

function startUploadWatch(onTick) {
  clearUploadWatch();
  _uploadWatchTimer = setInterval(() => {
    try {
      onTick && onTick();
    } catch (e) {}
  }, 600);
}

  // Cache de lentes vindas da coleção (Storefront JSON)
  let __lentesProductsCache = null;

  function splitTags(tags) {
    if (!tags) return [];
    if (Array.isArray(tags)) return tags.map((t) => String(t).trim()).filter(Boolean);
    // products.json retorna tags como string separada por vírgula
    return String(tags)
      .split(",")
      .map((t) => t.trim())
      .filter(Boolean);
  }

  function normTag(t) {
    return String(t || "").trim().toLowerCase();
  }

  async function fetchLentesProductsFromCollection() {
    if (__lentesProductsCache) return __lentesProductsCache;

    const tryUrls = [
      `/collections/${LENTES_COLLECTION_HANDLE}/products.json?limit=250`,
      `/collections/all/products.json?limit=250`,
    ];

    for (const url of tryUrls) {
      try {
        const res = await fetch(url, { credentials: "same-origin" });
        if (!res.ok) continue;
        const data = await res.json();
        if (Array.isArray(data?.products)) {
          __lentesProductsCache = data.products;
          return __lentesProductsCache;
        }
      } catch (_) {}
    }

    __lentesProductsCache = [];
    return __lentesProductsCache;
  }

  async function resolveLenteVariantIdByTag(tag) {
    const want = normTag(tag);

    // ✅ força os IDs oficiais (não depende da ordem de variantes do products.json)
    if (want === normTag(TAG_LENTE_LEVE)) return Number(VARIANT_ID_LEVE);
    if (want === normTag(TAG_LENTE_MODERADO)) return Number(VARIANT_ID_MODERADO);
    if (want === normTag(TAG_LENTE_ALTO)) return Number(VARIANT_ID_ALTO);

    // fallback (se um dia você criar outras lentes por tag)
    const products = await fetchLentesProductsFromCollection();
    for (const p of products) {
      const tags = splitTags(p?.tags);
      if (tags.some((t) => normTag(t) === want)) {
        const vId = p?.variants?.[0]?.id;
        if (vId) return Number(vId);
      }
    }

    throw new Error(`Lente não encontrada para a tag: ${tag}`);
  }


  function onReady(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }


  // ✅ Neutraliza overlays invisíveis que podem ficar por cima de ícones/botões
  // (ex.: drawer overlay do tema com opacity 0, mas ainda capturando clique).
  function neutralizeInvisibleOverlays() {
    try {
      const sel = [
         '.drawer__overlay',
         '.cart-drawer__overlay',
         '.drawer-overlay',
         '.drawer__backdrop',
         '.site-overlay',
         '.modal__overlay',
         '.modal-overlay',
         '.overlay',
         '.backdrop',
         '[data-overlay]',
         '[data-cart-overlay]',
         '[data-drawer-overlay]'
       ].join(',');

      document.querySelectorAll(sel).forEach((el) => {
        try {
          if (!el) return;

          const c = getComputedStyle(el);
          const br = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          const big = !!br && (br.width >= window.innerWidth * 0.6) && (br.height >= window.innerHeight * 0.4);

          const op = parseFloat(c.opacity || "1");
          const invisible =
            c.display === "none" ||
            c.visibility === "hidden" ||
            (Number.isFinite(op) && op <= 0.12) ||
            el.getAttribute("aria-hidden") === "true";

          // Se está invisível e grande, não deve capturar clique.
          // Importante: se voltar a ficar visível, remove o bloqueio inline para não quebrar abertura/fechamento.
          if (big && invisible) {
            if (el.style && el.style.pointerEvents !== "none") el.style.pointerEvents = "none";
          } else {
            if (el.style && el.style.pointerEvents === "none") el.style.pointerEvents = "";
          }
        } catch (_) {}
      });
    } catch (_) {}
  }

  function hardResetThemeDrawerLocks() {
    try {
      const body = document.body;
      const html = document.documentElement;

      ["cart-drawer-open","drawer-open","js-drawer-open","js-drawer-open-right","js-cart-open","modal-open","no-scroll","scroll-locked","overflow-hidden","lock-scroll","is-locked"].forEach((c) => {
        try { body && body.classList && body.classList.remove(c); } catch (_) {}
        try { html && html.classList && html.classList.remove(c); } catch (_) {}
      });

      try { if (body && body.style) body.style.overflow = ""; } catch (_) {}
      try { if (html && html.style) html.style.overflow = ""; } catch (_) {}

      try { document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true })); } catch (_) {}

      // também limpa overlays invisíveis que podem ficar capturando clique
      try { neutralizeInvisibleOverlays(); } catch (_) {}
    } catch (_) {}
  }

  // ✅ Se a página foi recarregada após adicionar ao carrinho, garante que nada ficou "travado"
  // (scroll lock, overlay invisível, etc.) — isso evita o carrinho do tema parar de abrir.
  function bootAfterReloadCleanup() {
    let flag = false;
    let openFlag = false;

    try { flag = sessionStorage.getItem("__fozoco_reload_after_add") === "1"; } catch (_) {}
    try { openFlag = sessionStorage.getItem("__fozoco_open_cart_after_reload") === "1"; } catch (_) {}

    if (!flag && !openFlag) return;

    try { sessionStorage.removeItem("__fozoco_reload_after_add"); } catch (_) {}
    try { sessionStorage.removeItem("__fozoco_open_cart_after_reload"); } catch (_) {}

    // Remove o drawer/overlay de lentes (se tiver sobrado) e destrava locks do tema
    try { cleanupLentesLayers({ remove: true }); } catch (_) {}
    try { hardResetThemeDrawerLocks(); } catch (_) {}
    try { restoreCartUiPointerEvents(); } catch (_) {}
    try { ensureCtasEnabled(); } catch (_) {}

    // ✅ opcional: após reload, abrir o drawer do carrinho (sem navegar para /cart)
    // Por padrão fica DESLIGADO porque alguns temas travam quando tenta abrir cedo demais.
    try {
      const isCartPage = /^\/cart(\/|$)/.test(window.location.pathname || "");
      const allowOpenAfterReload = !!(FLAGS && FLAGS.open_cart_after_reload);

      if (openFlag && allowOpenAfterReload && !isCartPage) {
        const doOpen = () => { try { neutralizeInvisibleOverlays(); } catch (_) {}
        try { openUpCart({ force: true }); } catch (_) {} };

        // espera um pouco mais para o tema/app inicializar
        setTimeout(doOpen, 350);

        // último fallback: se abriu overlay mas não abriu drawer, destrava e tenta de novo
        setTimeout(() => {
          try {
            if (typeof cartDrawerLooksOpen === "function" && !cartDrawerLooksOpen()) {
              try { hardResetThemeDrawerLocks(); } catch (_) {}
              try { restoreCartUiPointerEvents(); } catch (_) {}
              try { doOpen(); } catch (_) {}
            }
          } catch (_) {}
        }, 1200);
      }
    } catch (_) {}

    // Sempre: limpar overlays invisíveis que possam estar bloqueando clique do CTA
    try {
      setTimeout(() => { try { unblockCtaInteraction(); } catch (_) {} }, 250);
      setTimeout(() => { try { unblockCtaInteraction(); } catch (_) {} }, 900);
    } catch (_) {}
  }


// roda no load normal + bfcache (pageshow)
  onReady(bootAfterReloadCleanup);
  window.addEventListener("pageshow", bootAfterReloadCleanup);
  function getProductHandleFromURL() {
    const parts = window.location.pathname.split("/").filter(Boolean);
    const idx = parts.indexOf("products");
    return idx >= 0 && parts[idx + 1] ? parts[idx + 1] : null;
  }

  function getProductTagsFromPage() {
    // tentativa rápida: ShopifyAnalytics/meta (quando disponível)
    try {
      const metaTags = window?.ShopifyAnalytics?.meta?.product?.tags;
      if (Array.isArray(metaTags) && metaTags.length) return metaTags;
    } catch (_) {}
    const scripts = Array.from(document.querySelectorAll('script[type="application/json"]'));
    for (const s of scripts) {
      try {
        const data = JSON.parse(s.textContent || "");
        if (Array.isArray(data?.tags)) return data.tags;
        if (Array.isArray(data?.product?.tags)) return data.product.tags;
      } catch (_) {}
    }
    return [];
  }

  async function fetchProductTagsFromHandle(handle) {
    const res = await fetch(`/products/${handle}.js`, { headers: { Accept: "application/json" }, credentials: "same-origin" });
    if (!res.ok) throw new Error("Falha ao buscar produto .js");
    const data = await res.json();
    return Array.isArray(data?.tags) ? data.tags : [];
  }

  async function productHasTag(tag) {
    const want = normTag(tag);
    const tagsFromPage = getProductTagsFromPage();
    if (tagsFromPage.length) return tagsFromPage.some((t) => normTag(t) === want);

    const handle = getProductHandleFromURL();
    if (!handle) return false;

    try {
      const tags = await fetchProductTagsFromHandle(handle);
      return tags.some((t) => normTag(t) === want);
    } catch (_) {
      return false;
    }
  }

  function cartDrawerLooksOpen() {
      // Elementos comuns de cart drawer em vários temas (Pipeline/UpCart)
      const drawer =
        document.querySelector("upcart-drawer, upcart-cart, .upcart__drawer, .upcart__cart, #upcart, #upcart-root, cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart, [data-drawer=\"cart\"], [data-cart-drawer], [data-cart-drawer-container], .ajax-cart__drawer");

      const body = document.body;
      const html = document.documentElement;

      const classOpen = (el, names) =>
        !!(el && el.classList && names.some((n) => el.classList.contains(n)));

      const attrOpen = (el) => {
        if (!el || !el.getAttribute) return false;
        const ariaHidden = el.getAttribute("aria-hidden");
        const ariaExpanded = el.getAttribute("aria-expanded");
        return (
          el.getAttribute("open") !== null ||
          ariaHidden === "false" ||
          ariaExpanded === "true"
        );
      };

      const isVisibleOnScreen = (el) => {
        try {
          if (!el) return false;
          const rect = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          if (!rect || rect.width < 10 || rect.height < 10) return false;

          const style = window.getComputedStyle ? getComputedStyle(el) : null;
          if (style) {
            const op = parseFloat(style.opacity || "1");
            if (style.display === "none" || style.visibility === "hidden") return false;
            if (Number.isFinite(op) && op <= 0.12) return false;
          }

          // Interseção com viewport (evita "aberto" mas fora da tela)
          const offscreen = rect.right <= 0 || rect.bottom <= 0 || rect.left >= window.innerWidth || rect.top >= window.innerHeight;
          if (offscreen) return false;

          return true;
        } catch (_) {
          return false;
        }
      };

      const bodyHasLock = classOpen(body, ["cart-drawer-open", "drawer-open", "js-drawer-open", "js-drawer-open-right", "js-cart-open"]) ||
                          classOpen(html, ["drawer-open", "js-drawer-open", "js-drawer-open-right"]);

      // Se o tema marcou "drawer-open", só consideramos aberto se o drawer realmente está visível.
      if (bodyHasLock) {
        if (!drawer) return true; // não conseguimos detectar o drawer; assume aberto
        return isVisibleOnScreen(drawer);
      }

      if (!drawer) return false;

      const drawerFlag = classOpen(drawer, ["open", "is-open", "active", "drawer-open", "is-visible", "visible"]) || attrOpen(drawer);
      if (drawerFlag) return isVisibleOnScreen(drawer);

      // Fallback visual
      return isVisibleOnScreen(drawer);
    }

  function tryOpenCartDrawer() {
      // 1) Apps (UpCart) - variações de nome global
try {
  if (window.upcart && typeof window.upcart.openCart === "function") {
    window.upcart.openCart();
    return true;
  }
} catch (_) {}

try {
  if (window.UpCart && typeof window.UpCart.openCart === "function") {
    window.UpCart.openCart();
    return true;
  }
} catch (_) {}

try {
  if (window.UpCart && typeof window.UpCart.open === "function") {
    window.UpCart.open();
    return true;
  }
} catch (_) {}


     
      // 1) Apps (UpCart) - cobre variações de nome + método
      try {
        const up =
          window.Upcart ||
          window.upcart ||
          window.UpCart ||
          window.upCart;

        if (up) {
          if (typeof up.openCart === "function") { up.openCart(); return true; }
          if (typeof up.open === "function") { up.open(); return true; }
          if (typeof up.openDrawer === "function") { up.openDrawer(); return true; }
          if (up.cart && typeof up.cart.open === "function") { up.cart.open(); return true; }
        }
      } catch (_) {}

  
      // 2) Dawn / custom element
      const dawnDrawer = document.querySelector("cart-drawer");
      if (dawnDrawer && typeof dawnDrawer.open === "function") {
        try { dawnDrawer.open(); } catch (_) {}
        return true;
      }
  
      // 3) Globais/Helpers comuns
      try {
        if (window.theme?.drawers && typeof window.theme.drawers.open === "function") {
          window.theme.drawers.open("cart");
          return true;
        }
      } catch (_) {}

      // Pipeline/variações: alguns temas usam ID diferente
      try {
        if (window.theme?.drawers && typeof window.theme.drawers.open === "function") {
          window.theme.drawers.open("CartDrawer");
          return true;
        }
      } catch (_) {}

      try {
        if (window.theme?.drawers && typeof window.theme.drawers.open === "function") {
          window.theme.drawers.open("cartDrawer");
          return true;
        }
      } catch (_) {}

      try {
        if (window.theme?.drawers && typeof window.theme.drawers.open === "function") {
          window.theme.drawers.open("drawer-cart");
          return true;
        }
      } catch (_) {}
  
      try {
        if (window.theme?.drawer && typeof window.theme.drawer.open === "function") {
          window.theme.drawer.open("cart");
          return true;
        }
      } catch (_) {}
  
      try {
        if (window.theme?.cartDrawer && typeof window.theme.cartDrawer.open === "function") {
          window.theme.cartDrawer.open();
          return true;
        }
      } catch (_) {}
  
      try {
        if (window.theme?.CartDrawer && typeof window.theme.CartDrawer.open === "function") {
          window.theme.CartDrawer.open();
          return true;
        }
      } catch (_) {}
  
      try {
        if (window.CartDrawer && typeof window.CartDrawer.open === "function") {
          window.CartDrawer.open();
          return true;
        }
      } catch (_) {}
  
      // 4) Eventos (Pipeline e outros temas)
      const evs = ["theme:cart:open", "cart:open", "ajaxCart:open"];
      for (const name of evs) {
        try {
          document.dispatchEvent(new CustomEvent(name, { bubbles: true }));
        } catch (_) {}
      }
  
      // Se abriu por evento, ótimo
      if (cartDrawerLooksOpen()) return true;
  
      // 5) Triggers de drawer (NÃO clicar em /cart para evitar navegar)
      const trigger =
        document.querySelector('[data-cart-drawer-open]') ||
        document.querySelector('[data-drawer-open="cart"]') ||
        document.querySelector('[data-drawer="cart"] [data-drawer-open]') ||
        document.querySelector('a[href="#CartDrawer"]') ||
        document.querySelector('button[name="open-cart"]');
  
      if (trigger) {
        try { trigger.click(); } catch (_) {}
        return true;
      }
  
      return false;
    }

  function openUpCart(opts = {}) {
    // Não redireciona para /cart. No máximo abre o drawer do carrinho.
    // - Para "após adicionar", respeita FLAGS.open_cart_after_add (se existir)
    // - Para clique do usuário no ícone do carrinho, usamos { force: true } (não pode depender dessa flag)
    const force = !!(opts && opts.force);
    if (!force && FLAGS && Object.prototype.hasOwnProperty.call(FLAGS, "open_cart_after_add") && !FLAGS.open_cart_after_add) return;

    const tries = [0, 120, 350, 800, 1400, 2200, 3200, 4500, 6500];
    let i = 0;
    const attempt = () => {
      try { tryOpenCartDrawer(); } catch (_) {}
      // Se já parece aberto, para.
      try { if (cartDrawerLooksOpen()) return; } catch (_) {}
      i += 1;
      if (i < tries.length) setTimeout(attempt, tries[i]);
    };

    attempt();
  }

  

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" });
    if (!res.ok) throw new Error(`Falha ao buscar carrinho: ${res.status}`);
    return res.json();
  }

  async function refreshThemeCart() {
    try {
      const cart = await fetchCart();
      document.dispatchEvent(new CustomEvent("theme:cart:change", { bubbles: true, detail: { cart } }));
      return cart;
    } catch (_) {
      return null;
    }
  }

  function toast(msg) {
    const text = String(msg || "").trim();
    if (!text) return;

    let el = document.getElementById("fozoco-lentes-toast");
    if (!el) {
      el = document.createElement("div");
      el.id = "fozoco-lentes-toast";
      el.style.position = "fixed";
      el.style.left = "50%";
      el.style.bottom = "18px";
      el.style.transform = "translateX(-50%)";
      el.style.zIndex = "10000";
      el.style.padding = "10px 14px";
      el.style.borderRadius = "999px";
      el.style.background = "rgba(15,118,110,.95)";
      el.style.color = "#fff";
      el.style.fontWeight = "700";
      el.style.fontSize = "13px";
      el.style.boxShadow = "0 12px 30px rgba(16,24,40,.18)";
      el.style.opacity = "0";
      el.style.transition = "opacity .18s ease";
      document.body.appendChild(el);
    }

    el.textContent = text;
    requestAnimationFrame(() => (el.style.opacity = "1"));
    clearTimeout(el._t);
    el._t = setTimeout(() => {
      el.style.opacity = "0";
    }, 2200);
  }

  async function afterAddToCart() {
    await refreshThemeCart();
    toast(copy("toast_added", "Adicionado ao carrinho"));

    // ✅ Opção: recarregar a página após adicionar (resolve CTA que "morre" sem refresh)
    // Por padrão, RECARREGA (a menos que o theme setting defina reload_after_add=false)
    const wantsReload = !(FLAGS && Object.prototype.hasOwnProperty.call(FLAGS, "reload_after_add") && !FLAGS.reload_after_add);
    if (wantsReload) {
      try { sessionStorage.setItem("__fozoco_reload_after_add", "1"); } catch (_) {}
      try { await openUpCart({ force: true }); } catch (_) {}
      
      // Opcional: abrir o carrinho automaticamente após o reload (por padrão fica DESLIGADO pra evitar travamentos em alguns temas)
      try { if (FLAGS && FLAGS.open_cart_after_reload) sessionStorage.setItem("__fozoco_open_cart_after_reload", "1"); } catch (_) {}
      // garante que não ficou overlay travando clique do carrinho
      try { closeDrawer(); } catch (_) {}
      try { cleanupLentesLayers({ remove: true }); } catch (_) {}

      // tenta destravar scroll/drawer do tema
      try { document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true })); } catch (_) {}
      try {
        document.body.style.overflow = "";
        document.documentElement.style.overflow = "";
      } catch (_) {}

      setTimeout(() => {
        try {
          sessionStorage.setItem("__fozoco_open_cart_after_reload", "1");
          sessionStorage.setItem("__fozoco_open_cart_after_reload_ts", String(Date.now()));
        } catch (_) {}

        // ✅ TESTE: pausa o reload
        // try { window.location.reload(); } catch (_) {}
      }, 180);

      // ✅ TESTE: não retorna aqui, para o fluxo continuar sem recarregar
      // return;

    }

    // fallback (sem reload): abrir o carrinho
    openUpCart();
  }


  // Auto-remover itens do bundle (óculos x lentes) quando um deles for removido no carrinho
  let __bundleSyncLock = false;

  async function syncBundledItemsOnce() {
    // Lock compartilhado com assets/fozoco-cart-guard.js, que roda a mesma
    // sincronização em todas as páginas. Sem isso as duas rodam juntas e os
    // /cart/change.js concorrentes removem a linha errada.
    if (__bundleSyncLock || window.__fozocoBundleSyncLock) return;
    __bundleSyncLock = true;
    window.__fozocoBundleSyncLock = true;

    try {
      const cart = await fetchCart();
      const groups = new Map();

      (cart.items || []).forEach((it, idx) => {
        const props = it && it.properties ? it.properties : {};
        const bid = props["_fozoco_bundle_id"] || props["_fozoco_bundle"] || props["fozoco_bundle_id"];
        if (!bid) return;

        const role = props["_fozoco_bundle_role"] || props["fozoco_bundle_role"] || "";
        if (!groups.has(bid)) groups.set(bid, []);
        groups.get(bid).push({ line: idx + 1, role: String(role || "").toLowerCase() });
      });

      const linesToRemove = [];
      groups.forEach((items) => {
        const hasOculos = items.some((i) => i.role === "oculos");
        const hasLente = items.some((i) => i.role === "lente");

        // ✅ Regra nova (pedido do cliente):
        // Se remover a LENTE, o ÓCULOS deve continuar no carrinho (checkout só com óculos).
        // Então só removemos LENTES órfãs quando NÃO existe óculos no bundle.
        if (!hasOculos && hasLente) {
          items
            .filter((i) => i.role === "lente")
            .forEach((i) => linesToRemove.push(i.line));
        }

        // Se tem óculos sem lente, não remove nada.
      });

      if (!linesToRemove.length) return;

      // remove de trás pra frente (evita shift de line)
      linesToRemove.sort((a, b) => b - a);

      for (const line of linesToRemove) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ line, quantity: 0 }),
          credentials: "same-origin",
        });
      }

      await refreshThemeCart();
    } catch (_) {
      // silencioso
    } finally {
      __bundleSyncLock = false;
      window.__fozocoBundleSyncLock = false;
    }
  }

  function setupBundleAutoRemove() {
    // roda apenas no carrinho (ou quando existir drawer/mini-cart)
    // const isCartPage = /^\/cart(\/|$)/.test(window.location.pathname || "");
    // if (!isCartPage) return;

    let t = null;
    const schedule = (force = false) => {
      clearTimeout(t);
      const ignoreUntil = force ? 0 : (window.__fozoco_bundle_ignore_until || 0);
      const delay = force ? 120 : Math.max(250, ignoreUntil - Date.now() + 350);
      t = setTimeout(syncBundledItemsOnce, delay);
    };

    // Pipeline costuma disparar este evento em mudanças do carrinho
    document.addEventListener("theme:cart:change", schedule);

    // fallback: cliques típicos de remover/atualizar
    document.addEventListener(
      "click",
      (e) => {
        const a = e.target && e.target.closest ? e.target.closest("a,button") : null;
        if (!a) return;

        const href = (a.getAttribute && a.getAttribute("href")) || "";
        const isRemove =
          (href && href.includes("/cart/change") && href.includes("quantity=0")) ||
          (href && href.includes("quantity=0")) ||
          a.matches('[data-cart-remove], [data-remove], .cart__remove, .cart-item__remove, .upcart-remove, .upcart-item-remove, [data-upcart-remove]');

        if (isRemove) schedule(true);
      setTimeout(() => schedule(true), 900);
        },
      true
    );

    document.addEventListener(
      "change",
      (e) => {
        const el = e.target;
        if (!el) return;
        if (
          el.matches('input[name="updates[]"]') ||
          el.matches('input[data-quantity-input]') ||
          el.matches('input[name="quantity"]')
        ) {
          schedule(true);
        }
      },
      true
    );

    // ✅ UpCart/app do carrinho costuma mexer via fetch/XHR sem disparar theme:cart:change
    // Então a gente observa chamadas a /cart/(add|change|update|clear).js e agenda o sync.
    if (!window.__fozoco_bundle_netwatch) {
      window.__fozoco_bundle_netwatch = true;

      const _fetch = window.fetch;
      window.fetch = function(input, init) {
        const url = (typeof input === 'string') ? input : ((input && input.url) || '');
        const isCartMut = /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url));
        const p = _fetch.apply(this, arguments);
        if (isCartMut) {
          try { p.finally(() => { schedule(); setTimeout(schedule, 450); }); } catch (_) { setTimeout(schedule, 250); }
        }
        return p;
      };

      const _open = XMLHttpRequest.prototype.open;
      const _send = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url) {
        try { this.__fozoco_url = url; } catch (_) {}
        return _open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function() {
        try {
          this.addEventListener('loadend', () => {
            const url = String(this.__fozoco_url || '');
            const isCartMut = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
            if (isCartMut) { schedule(); setTimeout(schedule, 450); }
            });
        } catch (_) {}
        return _send.apply(this, arguments);
      };
    }



// ✅ DOM watch: alguns temas atualizam o drawer/mini-cart sem usar fetch/XHR que conseguimos interceptar.
// Quando o conteúdo do carrinho muda no DOM, agenda o sync (evita ficar com óculos "com grau" sem lente).
if (!window.__fozoco_bundle_domwatch) {
  window.__fozoco_bundle_domwatch = true;

  let domTimer = null;
  const domSchedule = () => {
    // Só roda se existir alguma UI de carrinho na página
    const drawer =
      document.querySelector("#CartDrawer") ||
      document.querySelector("[data-cart-drawer]") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".drawer--cart") ||
      document.querySelector(".upcart-drawer") ||
      document.querySelector("#upcart-drawer") ||
      document.querySelector("[data-upcart]");

    if (!drawer) return;

    // Se o drawer não está visível/aberto, evita rodar sync desnecessário
    const isOpen =
      (drawer.classList && (drawer.classList.contains("open") || drawer.classList.contains("is-open"))) ||
      drawer.getAttribute("aria-hidden") === "false" ||
      drawer.getAttribute("data-open") === "true" ||
      (drawer.offsetParent !== null);

    if (!isOpen) return;

    clearTimeout(domTimer);
    domTimer = setTimeout(schedule, 140);
  };

  const obs = new MutationObserver(domSchedule);

  try {
    // Observa o body e reage apenas quando detectar alterações em um drawer aberto
    obs.observe(document.body, { subtree: true, childList: true, attributes: true });
  } catch (_) {}
}


    // primeira checagem
    schedule();
  }

function getCurrentVariantId() {
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput && idInput.value) return Number(idInput.value);

    const variantSelect = document.querySelector('form[action*="/cart/add"] select[name="id"]');
    if (variantSelect && variantSelect.value) return Number(variantSelect.value);

    const v = document.querySelector("[data-selected-variant]")?.getAttribute("data-selected-variant");
    if (v) return Number(v);

    return null;
  }

  function getQuantity() {
    const input =
      document.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      document.querySelector('input[name="quantity"]');

    const qty = parseInt(input?.value || "1", 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  async function addOculosToCart(variantId, qty, props = {}, file = null) {
    const formData = new FormData();
    formData.append("id", String(variantId));
    formData.append("quantity", String(qty));
    Object.keys(props).forEach((k) => formData.append(`properties[${k}]`, props[k]));
    if (file) {
      try {
        formData.append("properties[Receita (arquivo)]", file, (file.name || "receita"));
      } catch (_) {
        formData.append("properties[Receita (arquivo)]", file);
      }
    }

    try { window.__fozoco_bundle_ignore_until = Date.now() + 6000; } catch (_) {}

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData,
      credentials: "same-origin",
    });

    if (!res.ok) throw new Error(`Falha ao adicionar óculos: ${res.status}`);
    return res.json();
  }

  async function addLenteToCart(variantId, qty, props = {}) {
    const payload = { id: variantId, quantity: qty };
    if (props && typeof props === "object" && Object.keys(props).length) {
      payload.properties = props;
    }

    try { window.__fozoco_bundle_ignore_until = Date.now() + 6000; } catch (_) {}

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
      credentials: "same-origin",
    });

    if (!res.ok) throw new Error(`Falha ao adicionar lente: ${res.status}`);
    return res.json();
  }

  let drawerEl = null;
  let overlayEl = null;

  // Detecta UI do carrinho (Cart drawer / UpCart etc.) para evitar conflitos
    // Seletores do carrinho (cart drawer / UpCart etc.) para evitar conflitos
  // ⚠️ Importante: não use seletores genéricos tipo [class*="upcart"], porque alguns apps colocam classe no <body>
  // e isso faria TODO elemento parecer "dentro do carrinho", quebrando o CTA.
  const CART_UI_SELECTOR = [
    '#CartDrawer',
    'cart-drawer',
    '.cart-drawer',
    '[data-cart-drawer]',
    '.drawer--cart',
    '.drawer[data-drawer="cart"]',
    '.drawer[data-drawer-id="cart"]',

    // UpCart (mais específico)
    'upcart-drawer',
    'upcart-cart',
    '#upcart',
    '#upcart-root',
    '.upcart-drawer',
    '.upcart-cart',
    '.upcart__drawer',
    '.upcart__cart'
  ].join(', ');

    function isInCartUi(el) {
    try {
      if (!el || !el.closest) return false;
      const c = el.closest(CART_UI_SELECTOR);
      if (!c) return false;

      // Se o match cair no <body>/<html> por causa de classe global, ignora.
      if (c === document.body || c === document.documentElement) return false;

      return true;
    } catch (_) {
      return false;
    }
  }
  function applyLentesThemeVars() {
  try {
    if (!drawerEl) return;

    // 1) tenta pegar cor do botão principal (já virou "Escolher lentes e comprar")
    const btn =
      document.querySelector('[data-lentes-drawer-bound="1"]') ||
      document.querySelector('form[action*="/cart/add"] button, form[action*="/cart/add"] input[type="submit"]');

    let accent = btn ? (getComputedStyle(btn).backgroundColor || "") : "";

    // 2) fallback: tenta variáveis comuns de tema
    if (!accent || accent === "transparent" || accent === "rgba(0, 0, 0, 0)") {
      const root = getComputedStyle(document.documentElement);
      accent =
        (root.getPropertyValue("--color-accent") ||
          root.getPropertyValue("--color-primary") ||
          root.getPropertyValue("--color-button") ||
          "").trim();
    }

    if (!accent) return;

    drawerEl.style.setProperty("--lentes-accent", accent);

    // extrai RGB p/ sombras e bordas
    const m = accent.match(/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
    if (m) drawerEl.style.setProperty("--lentes-accent-rgb", `${m[1]},${m[2]},${m[3]}`);
  } catch (_) {}
}

  

  const state = { step: 1, tipo: null, grau: null, receitaEnvio: null, file: null, uploadOpen: false };

  function cleanupLentesLayers({ remove = false } = {}) {
    try {
      // Fecha TODOS (evita overlay “fantasma” bloqueando clique no carrinho)
      document.querySelectorAll(".lentes-overlay, .lentes-drawer").forEach((el) => {
        el.classList.remove("open");
        if (remove) el.remove();
      });
    } catch (_) {}
  }

  function closeDrawer() {
    // fecha o par atual
    try { if (drawerEl) drawerEl.classList.remove("open"); } catch (_) {}
    try { if (overlayEl) overlayEl.classList.remove("open"); } catch (_) {}

    // e garante que não sobrou nenhum overlay/drawer “aberto” no DOM
    cleanupLentesLayers({ remove: false });
  }
/* ===== FOZOCO • estoque do CTA de lentes (fix esgotado) ===== */
let __fozocoVariantsCache = null;
let __fozocoVariantsInflight = null;
let __fozocoCurrentVariantAvailable = null;

async function loadVariantAvailability() {
  if (__fozocoVariantsCache) return __fozocoVariantsCache;
  if (__fozocoVariantsInflight) return __fozocoVariantsInflight;
  const handle = getProductHandleFromURL();
  if (!handle) return null;
  __fozocoVariantsInflight = fetch(`/products/${handle}.js`, {
    headers: { Accept: "application/json" }, credentials: "same-origin",
  })
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      const map = {};
      if (data && Array.isArray(data.variants)) {
        data.variants.forEach((v) => { map[Number(v.id)] = !!v.available; });
      }
      __fozocoVariantsCache = map;
      return map;
    })
    .catch(() => null)
    .finally(() => { __fozocoVariantsInflight = null; });
  return __fozocoVariantsInflight;
}

function isSelectedVariantAvailable() {
  if (__fozocoCurrentVariantAvailable === true) return true;
  if (__fozocoCurrentVariantAvailable === false) return false;
  const id = getCurrentVariantId();
  if (id != null && __fozocoVariantsCache &&
      Object.prototype.hasOwnProperty.call(__fozocoVariantsCache, id)) {
    return !!__fozocoVariantsCache[id];
  }
  return true;
}

function applyCtaStockState() {
  try {
    const available = isSelectedVariantAvailable();
    document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (isInCartUi(form)) return;
      const btn =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]') ||
        form.querySelector('button[name="add"]');
      if (!btn || isInCartUi(btn)) return;
      if (available) {
        try { btn.disabled = false; } catch (_) {}
        try { btn.removeAttribute('disabled'); } catch (_) {}
        try { btn.removeAttribute('aria-disabled'); } catch (_) {}
        try { btn.classList.remove('is-loading','loading','disabled','is-disabled','btn--loading','button--loading'); } catch (_) {}
        try { delete btn.dataset.fozocoSoldOut; } catch (_) {}
      } else {
        try { btn.disabled = true; } catch (_) {}
        try { btn.setAttribute('disabled','disabled'); } catch (_) {}
        try { btn.setAttribute('aria-disabled','true'); } catch (_) {}
        try { btn.dataset.fozocoSoldOut = '1'; } catch (_) {}
      }
    });
  } catch (_) {}
}

document.addEventListener('theme:variant:change', (e) => {
  try {
    const v = e && e.detail ? e.detail.variant : null;
    __fozocoCurrentVariantAvailable = v ? !!v.available : null;
  } catch (_) { __fozocoCurrentVariantAvailable = null; }
  try { applyCtaStockState(); } catch (_) {}
}, true);
/* ===== fim ===== */

 function openDrawer() {
    // variante esgotada: não abre o fluxo de lentes (mantém ESGOTADO)
    if (!isSelectedVariantAvailable()) { try { applyCtaStockState(); } catch (_) {} return; }

    // Se algum app/tema removeu o drawer do DOM, recria com segurança
    if (
      !drawerEl ||
      !overlayEl ||
      !document.body.contains(drawerEl) ||
      !document.body.contains(overlayEl)
    ) {
      drawerEl = null;
      overlayEl = null;
      createDrawer();
    }

    applyLentesThemeVars();
    state.step = 1;
    state.tipo = null;
    state.grau = null;
    state.receitaEnvio = null;
    state.file = null;
    state.uploadOpen = false;

    render();
    drawerEl.classList.add("open");
    overlayEl.classList.add("open");
  }



  function createDrawer() {
    overlayEl = document.createElement("div");
    overlayEl.className = "lentes-overlay";
    overlayEl.addEventListener("click", closeDrawer);

    drawerEl = document.createElement("div");
    drawerEl.className = "lentes-drawer";
    drawerEl.innerHTML = `
      <div class="lentes-header">
        <div class="lentes-title">${escapeHtml(copy("drawer_title", "Escolha seu tipo de lente"))}</div>
        <button class="lentes-close" type="button" aria-label="Fechar">✕</button>
      </div>
      <div class="lentes-body"><div id="lentes-step"></div></div>
      <div class="lentes-footer">
        <button id="lentes-back" class="lentes-btn ghost" type="button">Voltar</button>
        <button id="lentes-next" class="lentes-btn primary" type="button">Continuar</button>
      </div>
    `;

    const style = document.createElement("style");
    style.textContent = `
      .lentes-overlay{position:fixed;inset:0;background:rgba(0,0,0,.45);opacity:0;pointer-events:none;transition:opacity .2s;z-index:9998}
      .lentes-overlay.open{opacity:1;pointer-events:auto}
      .lentes-drawer{position:fixed;top:0;right:0;height:100%;width:min(420px,100%);background:#fff;transform:translateX(100%);transition:transform .25s;z-index:9999;display:flex;flex-direction:column}
      .lentes-drawer.open{transform:translateX(0)}
      .lentes-header{display:flex;align-items:center;justify-content:space-between;padding:16px;border-bottom:1px solid rgba(0,0,0,.08)}
      .lentes-title{font-size:16px;font-weight:600}
      .lentes-close{border:0;background:transparent;font-size:18px;cursor:pointer}
      .lentes-body{padding:16px;overflow:auto;flex:1}
      .lentes-footer{display:flex;gap:10px;padding:16px;border-top:1px solid rgba(0,0,0,.08)}
      .lentes-btn{flex:1;border-radius:10px;padding:12px 14px;font-weight:600;cursor:pointer;border:1px solid rgba(0,0,0,.12);background:#fff}
      .lentes-btn.primary{background:#197278;color:#fff;border-color:#197278}
      .lentes-btn.ghost{background:#fff;color:#111}
      .lentes-card{border:1px solid rgba(0,0,0,.1);border-radius:12px;padding:14px;cursor:pointer}
      .lentes-card[data-tipo="sem_grau"]{order:0}
      .lentes-card[data-tipo="com_grau"]{order:1}
      .lentes-grid{display:grid;gap:10px}
      .lentes-muted{color:#6b7280;font-size:12px;line-height:1.35}
.lentes-h{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px;
  font-weight:900;
  font-size:14px;      /* diminui um pouco o texto */
  line-height:1.15;
  margin:0 0 6px;
  flex-wrap:nowrap;    /* evita o pill cair pra baixo */
}

.lentes-pill{
  margin-left:auto;    /* empurra o preço pra direita */
  white-space:nowrap;  /* nunca quebra o preço */
  flex:0 0 auto;
  font-size:12px;
  padding:4px 8px;
  border-radius:999px;
}

      .lentes-field{margin-top:12px}
      .lentes-label{font-size:13px;font-weight:600;margin-bottom:6px}
      .lentes-input{width:100%;padding:10px 12px;border-radius:10px;border:1px solid rgba(0,0,0,.15)}
      .lentes-error{color:#b91c1c;font-size:12px;margin-top:6px;display:none}

      .lentes-upload-back{background:none;border:0;cursor:pointer;padding:6px 8px;margin:0 0 10px;border-radius:10px;font-weight:600}
      .lentes-upload-back:hover{background:rgba(0,0,0,.06)}
      .lentes-file{width:100%;padding:10px 12px;border:1px solid rgba(0,0,0,.14);border-radius:12px;background:#fff;margin:0 0 10px}
      .lentes-app-upload-slot{margin:8px 0 10px}
      .lentes-app-upload-slot .shopify-app-block{margin:0}

      /* Botão secundário (Enviar anexo) — mesmo padrão e cor da loja */
.lentes-btn.ghost {
  width: 100%;
  border-radius: 14px;
  padding: 12px 14px;
  font-weight: 900;
  letter-spacing: .2px;

  background: rgba(var(--lentes-accent-rgb), .08);
  border: 1px solid rgba(var(--lentes-accent-rgb), .35);
  color: rgba(var(--lentes-accent-rgb), 1);

  transition: transform .12s ease, box-shadow .12s ease, filter .12s ease;
}

.lentes-btn.ghost:hover {
  filter: brightness(.98);
  box-shadow: 0 10px 22px rgba(16,24,40,.08);
  transform: translateY(-1px);
}

.lentes-btn.ghost:active {
  transform: translateY(0);
  box-shadow: none;
}

.lentes-btn.ghost:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(var(--lentes-accent-rgb), .20);
}

.lentes-btn.ghost[disabled] {
  opacity: .6;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}


      /* ===== PRO SKIN (override) ===== */
.lentes-drawer{
  --lentes-accent:#0f766e;
  --lentes-accent-rgb:15,118,110;
  --lentes-bg:#f7f7f8;
  --lentes-surface:#fff;
  --lentes-text:#0b1220;
  --lentes-muted:#667085;
  --lentes-border:rgba(16,24,40,.12);
  --lentes-radius:16px;

  font-family: inherit;
  box-shadow: -16px 0 48px rgba(16,24,40,.14);
}

.lentes-overlay{ backdrop-filter: blur(2px); }

.lentes-header{
  position: sticky; top: 0; z-index: 2;
  background: rgba(255,255,255,.92);
  backdrop-filter: blur(10px);
}

.lentes-title{
  color: var(--lentes-text);
  font-weight: 800;
  font-size: 14px;
  letter-spacing: .2px;
}

.lentes-body{ background: var(--lentes-bg); padding: 18px; }

.lentes-step-title{
  margin: 4px 0 12px;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: .2px;
  color: var(--lentes-text);
}


/* Step 3: dá mais respiro entre as opções de envio da receita */
.lentes-step .lentes-card + .lentes-card{ margin-top: 10px; }

.lentes-grid{ gap: 12px; }

.lentes-card{
  background: var(--lentes-surface);
  border: 1px solid var(--lentes-border);
  border-radius: var(--lentes-radius);
  padding: 14px;
  transition: transform .12s ease, box-shadow .12s ease, border-color .12s ease;
}

.lentes-card:hover{
  transform: translateY(-1px);
  box-shadow: 0 10px 22px rgba(16,24,40,.08);
}

.lentes-card.is-selected{
  border-color: rgba(var(--lentes-accent-rgb), .85);
  box-shadow: 0 0 0 3px rgba(var(--lentes-accent-rgb), .16);
}

.lentes-h,
.lentes-card-title{
  color: var(--lentes-text);
  font-weight: 900;
}

.lentes-muted{
  color: var(--lentes-muted);
  font-size: 12px;
  line-height: 1.45;
}

.lentes-pill{
  background: rgba(var(--lentes-accent-rgb), .10);
  border: 1px solid rgba(var(--lentes-accent-rgb), .22);
  color: rgba(var(--lentes-accent-rgb), 1);
  font-weight: 900;
}

.lentes-note{
  margin-top: 12px;
  padding: 12px;
  border-radius: 14px;
  background: rgba(var(--lentes-accent-rgb), .08);
  border: 1px solid rgba(var(--lentes-accent-rgb), .18);
  color: var(--lentes-text);
  font-size: 12px;
  font-weight: 800;
}

.lentes-footer{ background: #fff; }

.lentes-btn{ border-radius: 14px; }
.lentes-btn.primary{
  background: var(--lentes-accent) !important;
  border-color: var(--lentes-accent) !important;
}
.lentes-btn.primary:hover{ filter: brightness(.96); }

.lentes-upload-back:hover{ background: rgba(var(--lentes-accent-rgb), .08); }

.lentes-file{
  border-radius: var(--lentes-radius);
  border: 1px dashed rgba(16,24,40,.22);
  background: #fff;
}

.lentes-file::file-selector-button{
  background: rgba(var(--lentes-accent-rgb), .10);
  border: 1px solid rgba(var(--lentes-accent-rgb), .22);
  color: rgba(var(--lentes-accent-rgb), 1);
  border-radius: 10px;
  padding: 8px 10px;
  margin-right: 10px;
  font-weight: 900;
  cursor: pointer;
}
.lentes-file::-webkit-file-upload-button{
  background: rgba(var(--lentes-accent-rgb), .10);
  border: 1px solid rgba(var(--lentes-accent-rgb), .22);
  color: rgba(var(--lentes-accent-rgb), 1);
  border-radius: 10px;
  padding: 8px 10px;
  margin-right: 10px;
  font-weight: 900;
  cursor: pointer;
}

/* ========== FOZOCO HOTFIX: espaçamentos do Step 3 (Enviar anexo) ========== */

/* Dá respiro entre o input/área e o botão */
.lentes-step #lentes-file,
.lentes-step .lentes-upload-area {
  margin-bottom: 12px !important;
}

/* O botão "Enviar anexo" fica muito colado no card abaixo: adiciona margem embaixo */
.lentes-step [data-confirm-upload-btn] {
  margin-top: 10px !important;      /* mantém parecido */
  margin-bottom: 14px !important;   /* separa do card */
}

/* Aumenta um pouco o espaçamento entre os cards do Step 3 (Anexar agora / WhatsApp etc) */
.lentes-step .lentes-card + .lentes-card {
  margin-top: 12px !important;
}





/* Removido: hotfix "link gigante no carrinho".
   Existia porque o UpCart renderizava a URL completa do anexo do Upload Lift.
   No Pipeline 8.2.0 snippets/cart-line-items.liquid ja imprime so o nome do
   arquivo (p.last | split: '/' | last), e o drawer do Section Store vive em
   shadow DOM, onde este CSS nao chega de qualquer forma. */




@media (prefers-reduced-motion: reduce){
  .lentes-overlay,.lentes-drawer,.lentes-card{ transition:none !important; }
}

    `;

    document.body.appendChild(style);
    document.body.appendChild(overlayEl);
    document.body.appendChild(drawerEl);

    drawerEl.querySelector(".lentes-close").addEventListener("click", closeDrawer);
    drawerEl.querySelector("#lentes-back").addEventListener("click", () => {
      if (state.step > 1) {
        if (state.step === 3) { state.uploadOpen = false; state.file = null; state.receitaEnvio = null; }
        state.step -= 1;
        render();
      } else closeDrawer();
    });
drawerEl.querySelector("#lentes-next").addEventListener("click", onNext);
  }

  // TEXTOS: edite abaixo (Ctrl+F por frases como "Escolha seu tipo de lente")
  function stepContent() {
    if (state.step === 1) {
      return `
        <div class="lentes-grid">
          <div class="lentes-card" data-tipo="com_grau">
            <div class="lentes-h">COM GRAU | LENTES ANTI LUZ AZUL</div>
            <div class="lentes-muted">Lentes monofocais para correção de miopia, hipermetropia ou astigmatismo, com proteção anti luz azul e tratamento antirreflexo.</div>
          </div>
          <div class="lentes-card" data-tipo="sem_grau">
            <div class="lentes-h">SEM GRAU | LENTES ANTI LUZ AZUL</div>
            <div class="lentes-muted">Lentes sem grau feitas para quem busca estilo e conforto visual, ideais para quem passa horas em frente às telas. Menos cansaço e desconforto visual.</div>
          </div>
        </div>`;
    }

    if (state.step === 2 && state.tipo === "com_grau") {
      return `
        <div class="lentes-grid">
          <div class="lentes-card" data-grau="leve">
            <div class="lentes-h">${escapeHtml(copy("grau_leve_title", "GRAU LEVE | até +/- 2.75"))} <span class="lentes-pill" data-lente-price="LENTE_GRAU_LEVE">—</span></div>
            <div class="lentes-muted">
              Lentes com espessura padrão, feitas de resina com tratamento anti-reflexo e proteção anti luz azul.<br>
              Contemplam hipermetropia e miopia até +/- 2.75 e astigmatismo até -2.00<br><br>
              (Prazo de produção: 4 à 8 dias úteis)
            </div>
          </div>

          <div class="lentes-card" data-grau="moderado">
            <div class="lentes-h">${escapeHtml(copy("grau_moderado_title", "GRAU MODERADO | até +/- 4.00"))} <span class="lentes-pill" data-lente-price="LENTE_GRAU_MODERADO">—</span>
</div>
            <div class="lentes-muted">
              Lentes com espessura padrão, feitas de resina com tratamento anti-reflexo e proteção anti luz azul.<br>
              Contemplam hipermetropia e miopia até +/- 4.00 e astigmatismo até -2.00.<br><br>
              (Prazo de produção: 4 à 8 dias úteis)
            </div>
          </div>
                    <div class="lentes-card" data-grau="alto">
            <div class="lentes-h">${escapeHtml(copy("grau_alto_title", "GRAU ALTO | até +/- 6.00"))} <span class="lentes-pill" data-lente-price="LENTE_GRAU_ALTO">—</span>
</div>
            <div class="lentes-muted">
              Lentes de alto índice, mais finas e leves, com tratamento anti-reflexo e proteção anti luz azul. Contemplam hipermetropia e miopia até +/- 6.00 e astigmatismo até -4.00.<br><br>
              (Prazo de produção: 4 à 8 dias úteis)
            </div>
          </div>

          <div class="lentes-muted" style="margin-top:8px"><b>ATENÇÃO:</b> O PRAZO DE PRODUÇÃO DEVE SER SOMADO AO PRAZO DE ENTREGA. <br> <br> NO MOMENTO NÃO FAZEMOS LENTES COM ADIÇÃO. SINALIZADO EM SUA RECEITA COMO “ADIÇÃO” OU “AD”, VERIFIQUE A SUA RECEITA ANTES DE FINALIZAR O PEDIDO.</div>
        </div>`;
    }

    if (state.step === 2 && state.tipo === "sem_grau") {
      return `
        <div>
          <div class="lentes-h">SEM GRAU | LENTES ANTI LUZ AZUL</div>
          <div class="lentes-muted">Lentes sem grau feitas para quem busca estilo e conforto visual, ideais para quem passa horas em frente às telas. Menos cansaço e desconforto visual.</div>
          <div class="lentes-muted" style="margin-top:10px"><b>ADICIONA ÓCULOS AO CARRINHO</b> PRODUTO SEM EXTRA</div>
        </div>`;
    }

    if (state.step === 3 && state.tipo === "com_grau") {
      const uploadOpen = !!state.uploadOpen;

      const uploadSection = uploadOpen
      ? `
  <button type="button" class="lentes-upload-back" data-upload-back aria-label="Voltar">←</button>
  <div class="lentes-upload-area">
    <input id="lentes-file" class="lentes-file" type="file" accept="image/*,.pdf" />
  </div>
  <div id="lentes-app-upload-wrap" style="display:none">
    <div id="lentes-app-upload-slot" class="lentes-app-upload-slot"></div>
  </div>
  <button
  type="button"
  class="lentes-btn ghost"
  data-confirm-upload-btn
  style="width:100%; margin-top:10px;"
>
  Enviar anexo
</button>
  <div id="lentes-file-error" class="lentes-error" style="display:none;">Envie um PDF ou imagem (JPG/PNG) para continuar.</div>
  <div class="lentes-card" data-confirm-upload>
    <div class="lentes-card-title">${escapeHtml(copy("opt_send_attached", "Enviar arquivo anexado acima"))}</div>
    <div class="lentes-muted">Selecione esta opção após ter inserido seu arquivo acima.</div>
  </div>

`
      : `
          <div class="lentes-card" data-open-upload>
            <div class="lentes-card-title">${escapeHtml(copy("opt_attach_now", "Anexar agora"))}</div>
            <div class="lentes-muted">Recomendado.</div>
          </div>
        `;

      return `
        <div class="lentes-step">
          <h2 class="lentes-step-title">${escapeHtml(copy("step3_title", "ESCOLHA COMO ENVIAR SUA RECEITA"))}</h2>

          ${uploadSection}

          <div class="lentes-card" data-receita="whatsapp">
            <div class="lentes-card-title">${escapeHtml(copy("opt_send_whatsapp", "Enviar depois via WhatsApp"))}</div>
            <div class="lentes-muted">Caso não envie sua receita, entraremos em contato.</div>
          </div>

          <div class="lentes-note">ATENÇÃO: O PRAZO DE PRODUÇÃO DEVE SER SOMADO AO PRAZO DE ENTREGA. <br><br> NO MOMENTO NÃO FAZEMOS LENTES COM ADIÇÃO. SINALIZADO EM SUA RECEITA COMO “ADIÇÃO” OU “AD”, VERIFIQUE A SUA RECEITA ANTES DE FINALIZAR O PEDIDO.</div>
        </div>
      `;
    }

    return `<div class="lentes-muted">Carregando…</div>`;
  }

  function bindStepEvents() {
    const stepEl = drawerEl.querySelector("#lentes-step");
    if (!stepEl) return;

    const selectCard = (card) => {
      stepEl.querySelectorAll(".lentes-card").forEach((c) => c.classList.remove("is-selected"));
      if (card) card.classList.add("is-selected");
    };

    // aplica seleção ao renderizar (quando volta de upload, etc.)
    if (state.step === 1 && state.tipo) selectCard(stepEl.querySelector(`[data-tipo="${state.tipo}"]`));
    if (state.step === 2 && state.grau) selectCard(stepEl.querySelector(`[data-grau="${state.grau}"]`));
    if (state.step === 3) {
      if (state.receitaEnvio === "whatsapp") selectCard(stepEl.querySelector(`[data-receita="whatsapp"]`));
      if (state.receitaEnvio === "upload_agora") selectCard(stepEl.querySelector(`[data-confirm-upload]`));
    }


    stepEl.querySelectorAll("[data-tipo]").forEach((el) => {
      el.addEventListener("click", async () => {
        state.tipo = el.getAttribute("data-tipo");
        state.grau = null;
        state.receitaEnvio = null;
        state.file = null;

        // SEM GRAU: adiciona imediatamente (sem passos extras)
        if (state.tipo === "sem_grau") {
          state.step = 2; // mantém compatibilidade com o fluxo
          await onNext();
          return;
        }

        state.step = 2;
        render();
      });
    });
stepEl.querySelectorAll("[data-grau]").forEach((el) => {
      el.addEventListener("click", () => {
        state.grau = el.getAttribute("data-grau");
        state.receitaEnvio = null;
        state.file = null;
        state.uploadOpen = false;
        state.receitaEnvio = null;
        state.step = 3;
        render();
      });
    });

    stepEl.querySelectorAll("[data-receita]").forEach((el) => {
      el.addEventListener("click", async () => {
        state.receitaEnvio = el.getAttribute("data-receita");
        const err = stepEl.querySelector("#lentes-file-error");
        if (err) err.style.display = "none";
        renderFooter();

        if (state.receitaEnvio === "whatsapp" && state.step === 3 && state.tipo === "com_grau") {
          await onNext();
        }
      });
    });

    // Upload: abre/fecha o seletor de arquivo (para não poluir a tela)
    const openUpload = stepEl.querySelector("[data-open-upload]");
    if (openUpload) {
      openUpload.addEventListener("click", () => {
        state.uploadOpen = true;
        state.receitaEnvio = "upload_agora";
        clearUploadWatch();
        restoreUploadApp();
        render();
      });
    }

    const uploadBack = stepEl.querySelector("[data-upload-back]");
    if (uploadBack) {
      uploadBack.addEventListener("click", () => {
        state.uploadOpen = false;
        state.receitaEnvio = null;
        clearUploadWatch();
        restoreUploadApp();
        render();
      });
    }

    const confirmUpload = stepEl.querySelector("[data-confirm-upload]");
    const confirmUploadBtn = stepEl.querySelector("[data-confirm-upload-btn]");
    if (confirmUploadBtn && confirmUpload) {
      confirmUploadBtn.addEventListener("click", () => confirmUpload.click());
    }

    if (confirmUpload) {
      confirmUpload.addEventListener("click", async () => {
        state.receitaEnvio = "upload_agora";

        const err = stepEl.querySelector("#lentes-file-error");
        if (err) {
          err.textContent = "Envie um PDF ou imagem (JPG/PNG) para continuar.";
          err.style.display = "none";
        }

        // Arquivo pode vir do input do drawer (#lentes-file) OU do app de upload (se existir)
        const file = getUploadAppSelectedFile();
        const appProps = getUploadAppProperties();

        if (file) {
          if (!isAllowedRecipeFile(file)) {
            if (err) {
              err.textContent = "Formato inválido. Envie PDF ou imagem (JPG/PNG).";
              err.style.display = "block";
            }
            return;
          }
          state.file = file;
        } else {
          state.file = null;
        }

        // Libera se tiver arquivo OU se o app já preencheu `properties[...]` (geralmente um link/ID)
        if (!state.file && !hasUploadAppValue(appProps)) {
          if (err) err.style.display = "block";
          return;
        }

        await onNext();
      });
    }


    // Captura mudança do input de arquivo do drawer
    const fileInput = stepEl.querySelector("#lentes-file");
    if (fileInput) {
      fileInput.addEventListener("change", () => {
        try {
          const f = fileInput.files && fileInput.files.length ? (fileInput.files[0] || null) : null;
          state.file = f;
          const err = stepEl.querySelector("#lentes-file-error");
          if (err) err.style.display = "none";
          renderFooter();
        } catch (_) {}
      });
    }

// Monta o bloco do app de upload dentro do drawer (se existir)
if (state.uploadOpen) {
  const slot = stepEl.querySelector("#lentes-app-upload-slot");
  const mounted = mountUploadAppInto(slot);

  if (mounted) {
    const wrap = stepEl.querySelector('#lentes-app-upload-wrap');
    if (wrap) wrap.style.display = 'block';
    startUploadWatch(() => {
      // se o usuário saiu da tela de upload, para de observar
      if (!state.uploadOpen) {
        clearUploadWatch();
        return;
      }

      // habilita/desabilita o botão do rodapé conforme o app preenche properties[...]
      renderFooter();

      const propsNow = getUploadAppProperties();
      if (hasUploadAppValue(propsNow)) clearUploadWatch();
    });
  } else {
    clearUploadWatch();
  }
} else {
  clearUploadWatch();
  restoreUploadApp();
}
  }

  function renderFooter() {
    const back = drawerEl.querySelector("#lentes-back");
    const next = drawerEl.querySelector("#lentes-next");

    back.textContent = state.step === 1 ? "Fechar" : "Voltar";

    const isFinal =
      (state.step === 2 && state.tipo === "sem_grau") ||
      (state.step === 3 && state.tipo === "com_grau");

    next.textContent = isFinal ? "Adicionar ao carrinho" : "Continuar";

    let canNext = true;

    // No passo 1, a navegação é pelos cards (evita avançar sem escolher).
    if (state.step === 1) canNext = false;

    // Passo 2 (com grau): precisa escolher o grau pelos cards.
    if (state.step === 2 && state.tipo === "com_grau" && !state.grau) canNext = false;

    // Passo 3 (com grau): precisa escolher como enviar a receita.
    if (state.step === 3 && state.tipo === "com_grau") {
      if (!state.receitaEnvio) canNext = false;
      if (state.receitaEnvio === "upload_agora" && state.uploadOpen && !state.file && !hasUploadAppValue(getUploadAppProperties())) canNext = false;
    }

    next.disabled = !canNext;
    next.style.opacity = canNext ? "1" : ".6";
  }

  function render() {
    const stepEl = drawerEl.querySelector("#lentes-step");
    if (!stepEl) return;

    stepEl.innerHTML = stepContent();

    // primeiro garante os cliques
    bindStepEvents();

    // depois tenta hidratar preço (sem quebrar nada)
    if (state.step === 2 && state.tipo === "com_grau") {
      try { hydrateGrauPrices(stepEl); } catch (e) {}
    }

    renderFooter();
  }



  async function onNext() {
    const next = drawerEl.querySelector("#lentes-next");
    if (!next) return;

    // Passo 1: a navegação é pelos cards
    if (state.step === 1) return;

    next.disabled = true;

    try {
      const oculosVariantId = getCurrentVariantId();
      if (!oculosVariantId) throw new Error("Não consegui identificar a variante do óculos.");
      const qty = getQuantity();

      // SEM GRAU: finaliza no passo 2
      if (state.step === 2 && state.tipo === "sem_grau") {
        await addOculosToCart(oculosVariantId, qty, {
          "Lente escolhida": "SEM GRAU | LENTES ANTI LUZ AZUL",
          "Receita status": "N/A",
        });
        closeDrawer(); cleanupLentesLayers({ remove: true }); await afterAddToCart(); return;
      }

      // COM GRAU: finaliza no passo 3
      if (state.step === 3 && state.tipo === "com_grau") {
        if (!state.grau) throw new Error("Selecione o grau da lente.");
        if (!state.receitaEnvio) throw new Error("Selecione como enviar sua receita.");

        if (state.receitaEnvio === "upload_agora") {
          // Libera se houver arquivo (input do drawer) OU se o app preencher `properties[...]` (link/ID)
          const appProps = getUploadAppProperties();
          const file = state.file || getUploadAppSelectedFile();
          if (file && !isAllowedRecipeFile(file)) {
            const err = drawerEl.querySelector("#lentes-file-error");
            if (err) {
              err.textContent = "Formato inválido. Envie PDF ou imagem (JPG/PNG).";
              err.style.display = "block";
            }
            next.disabled = false;
            return;
          }
          if (file) state.file = file;
          if (!state.file && !hasUploadAppValue(appProps)) {
            const err = drawerEl.querySelector("#lentes-file-error");
            if (err) {
              err.textContent = "Envie um PDF ou imagem (JPG/PNG) para continuar.";
              err.style.display = "block";
            }
            next.disabled = false;
            return;
          }
        }


           const lenteTag = state.grau === "leve"
          ? TAG_LENTE_LEVE
          : state.grau === "alto"
            ? TAG_LENTE_ALTO
            : TAG_LENTE_MODERADO;
      const lenteVariantId = await resolveLenteVariantIdByTag(lenteTag);
        const lenteTxt = state.grau === "leve"
          ? copy("grau_leve_title", "GRAU LEVE | até +/- 2.75")
          : state.grau === "alto"
            ? copy("grau_alto_title", "GRAU ALTO | até +/- 6.00")
            : copy("grau_moderado_title", "GRAU MODERADO | até +/- 4.00");
        const envioTxt = state.receitaEnvio === "upload_agora"
          ? copy("opt_send_attached", "Enviar arquivo anexado acima")
          : copy("opt_send_whatsapp", "Enviar depois via WhatsApp");

        const props = {
          "Lente escolhida": lenteTxt,
          "Envio da receita": envioTxt,
          "Receita status": state.receitaEnvio === "upload_agora" ? "RECEITA_OK" : "RECEITA_PENDENTE",
        };

        // ✅ WhatsApp: salva o link no pedido (fica oculto no carrinho pelo hideInternalCartProperties)
        if (state.receitaEnvio === "whatsapp") {
          const wa = buildWhatsAppUrlFull() || buildWhatsAppUrlShort();
          if (wa) props["_whatsapp_link"] = wa;
        }

        // Propriedades vindas do app de upload (inputs `properties[...]`)
        let fileToSend = null;
        if (state.receitaEnvio === "upload_agora") {
          const appProps = getUploadAppProperties();
          const hasApp = hasUploadAppValue(appProps);
          Object.keys(appProps).forEach((k) => {
            if (props[k] == null) props[k] = appProps[k];
          });
          // Se o app não preencheu nada, usa o arquivo do input do drawer como fallback
          if (!hasApp) {
            const f = state.file || getUploadAppSelectedFile();
            if (f && isAllowedRecipeFile(f)) {
              state.file = f;
              fileToSend = f;
            }
          }
        }
        const bundleId = `FZ-${Date.now()}-${Math.random().toString(16).slice(2)}`;
        props["_fozoco_bundle_id"] = bundleId;
        props["_fozoco_bundle_role"] = "oculos";

        const lenteProps = { "_fozoco_bundle_id": bundleId, "_fozoco_bundle_role": "lente" };

        await addOculosToCart(oculosVariantId, qty, props, fileToSend);
        await addLenteToCart(lenteVariantId, qty, lenteProps);

        closeDrawer(); cleanupLentesLayers({ remove: true }); await afterAddToCart(); return;
      }

      // fallback: avança
      state.step = Math.min(state.step + 1, 3);
      render();
      next.disabled = false;
    } catch (err) {
      alert(err?.message || "Erro ao adicionar ao carrinho.");
      next.disabled = false;
    }
  }

  function setupCTA() {
    // Ponto unico de bloqueio: protege as 3 chamadas (rebind, watch e onReady).
    if (!__fozocoLentesEnabled) return;

    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .filter((f) => f.querySelector('input[name="id"]') && !isInCartUi(f) && !(drawerEl && drawerEl.contains && drawerEl.contains(f)));


    // ✅ Intercepta o submit do form (mais robusto que click no botão)
    forms.forEach((form) => {
      try {
        if (form.__fozocoLentesSubmitBound) return;
        form.__fozocoLentesSubmitBound = true;

        form.addEventListener("submit", (e) => {
          // não mexe em forms dentro de carrinho/drawer
          try {
            if (typeof isInCartUi === "function" && isInCartUi(form)) return;
          } catch (_) {}

          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();

          try { ensureCtasEnabled(); } catch (_) {}
          try { unblockCtaInteraction(); } catch (_) {}

          // abre o drawer de lentes
          try { openDrawer(); } catch (_) {}
        }, true);
      } catch (_) {}
    });


    const label = copy("cta_text", "Escolher lentes e comprar");

    const bindBtn = (btn) => {
      if (!btn) return;


      // Não binda botões dentro do carrinho (UpCart/Cart drawer) para não quebrar checkout/remoção.
      if (isInCartUi(btn)) return;

      // ⚠️ Alguns apps re-renderizam/clonam o botão e COPIAM data-attrs.
      // Se a gente usar só data-attr como trava, o botão "novo" vem marcado mas sem listener.
      // Por isso usamos um expando JS (não é copiado no clone).
      if (btn.__fozocoLentesListenerBound) return;
      btn.__fozocoLentesListenerBound = true;
      btn.dataset.lentesDrawerBound = "1";
      btn.__fozocoLentesListenerBound = true;

      // Mantém data-attr para debug/rescue
      btn.dataset.lentesDrawerBound = "1";

      // Mantém o botão como submit (para não perder o estilo do tema). Só bloqueia a ação.
      if (btn.tagName && btn.tagName.toLowerCase() === "input") {
        try { btn.value = label; } catch (_) {}
      }
      try { btn.setAttribute("aria-label", label); } catch (_) {}

      // ✅ garante que o CTA nunca fique travado — mas só se a variante tiver estoque
      if (isSelectedVariantAvailable()) {
        try { btn.disabled = false; } catch (_) {}
        try { btn.removeAttribute("disabled"); } catch (_) {}
        try { btn.removeAttribute("aria-disabled"); } catch (_) {}
        try {
          btn.classList.remove("is-loading","loading","disabled","is-disabled","btn--loading","button--loading");
        } catch (_) {}
      }

      btn.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();
          openDrawer();
        },
        true
      );
    };

    for (const form of forms) {
      const btn =
        form.querySelector('button[type="submit"]') ||
        form.querySelector('input[type="submit"]') ||
        form.querySelector('button[name="add"]') ||
        form.querySelector('input[name="add"]');

      bindBtn(btn);

      // Enter no form (teclado) também abre o drawer, sem enviar para o carrinho
      if (!form.dataset.lentesSubmitBound) {
        form.dataset.lentesSubmitBound = "1";
        form.addEventListener(
          "submit",
          (e) => {
            const submitter = e.submitter || btn;
            if (submitter && submitter.dataset && submitter.dataset.lentesDrawerBound === "1") {
              e.preventDefault();
              openDrawer();
            }
          },
          true
        );
      }
    }

    // Alguns temas criam botões fora do form (sticky)
    const extraBtns = document.querySelectorAll('button[name="add"], .product-form__submit');
    extraBtns.forEach((b) => { if (!isInCartUi(b)) bindBtn(b); });

    fixProductQtyButtons();
  }

  
  // Evita que botões de quantidade (-/+) virem submit e adicionem item ao carrinho
  function fixProductQtyButtons() {
    const forms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .filter((f) => f.querySelector('input[name="id"]') && !isInCartUi(f) && !(drawerEl && drawerEl.contains && drawerEl.contains(f)));

    const isMainSubmit = (b) => {
      try {
        if (!b) return false;
        // não mexer no CTA de lentes nem no submit principal
        if (b.getAttribute('data-lentes-drawer-bound') === '1') return true;
        return b.matches('[name="add"], [data-add-to-cart], .product-form__submit, .add-to-cart, .product__submit, [data-cart-submit], button[type="submit"], input[type="submit"]');
      } catch (_) {
        return false;
      }
    };

    const looksLikeQtyButton = (b, qtyInput) => {
      try {
        if (!b || (b.tagName || '').toLowerCase() !== 'button') return false;

        const txt = (b.textContent || '').trim();
        const aria = String((b.getAttribute('aria-label') || b.getAttribute('title') || '')).toLowerCase();
        const cls = String(b.className || '').toLowerCase();

        if (txt === '-' || txt === '+') return true;
        if (/decrease|increase|diminuir|aumentar|menos|mais/.test(aria)) return true;

        // classes comuns (quantity__button, qty__adjust, etc.)
        if (/(^|\s)(qty|quant|quantity|minus|plus|inc|dec)(\s|$)/.test(cls) || /qty|quant|quantity|minus|plus|inc|dec/.test(cls)) return true;

        // data-* attrs comuns em temas
        const names = (typeof b.getAttributeNames === 'function') ? b.getAttributeNames() : [];
        if (names.some((n) => n.startsWith('data-') && /(qty|quantity|minus|plus|inc|dec)/.test(n))) return true;

        // dentro de wrapper de quantidade
        if (qtyInput) {
          const wrap =
            qtyInput.closest('.quantity, .qty, .product__quantity, .product-form__quantity, .product__quantity-wrapper, [data-quantity-wrapper], [data-quantity], [data-qty]') ||
            qtyInput.parentElement;

          if (wrap && wrap.contains(b)) return true;

          // mesmo pai/avô do input de quantidade (fallback)
          let p = b.parentElement;
          for (let i = 0; i < 3 && p; i += 1) {
            if (p.contains(qtyInput)) return true;
            p = p.parentElement;
          }
        }
      } catch (_) {}
      return false;
    };

    for (const form of forms) {
      const qtyInput = form.querySelector('input[name="quantity"]');
      const btns = Array.from(form.querySelectorAll('button'));

      for (const b of btns) {
        if (!b || isInCartUi(b)) continue;
        if (isMainSubmit(b)) continue;

        if (!looksLikeQtyButton(b, qtyInput)) continue;

        // default de <button> dentro de <form> é submit -> vira /cart/add
        try { b.type = 'button'; } catch (_) {}
        try { b.setAttribute('type', 'button'); } catch (_) {}
      }
    }
  }

function ensureCtasEnabled() {
    try {
      const available = isSelectedVariantAvailable();
      document.querySelectorAll('[data-lentes-drawer-bound="1"]').forEach((btn) => {
        if (!available) {
          try { btn.disabled = true; } catch (_) {}
          try { btn.setAttribute('disabled','disabled'); } catch (_) {}
          try { btn.setAttribute('aria-disabled','true'); } catch (_) {}
          return;
        }
        try { btn.disabled = false; } catch (_) {}
        try { btn.removeAttribute('disabled'); } catch (_) {}
        try { btn.removeAttribute('aria-disabled'); } catch (_) {}
        try { btn.classList.remove('is-loading','loading','disabled','is-disabled','btn--loading','button--loading'); } catch (_) {}
      });
    } catch (_) {}
  }

  // ✅ Re-binda o CTA caso UpCart/tema recrie o botão (perde o listener)
    if (!window.__fozoco_cta_rebind) {
      window.__fozoco_cta_rebind = true;

      let _t = null;
      const rebind = () => {
        clearTimeout(_t);
        _t = setTimeout(() => {
          try { setupCTA(); } catch (_) {}
          try { ensureCtasEnabled(); } catch (_) {}
          try { unblockCtaInteraction(); } catch (_) {}
        }, 120);
      };

      // Pipeline dispara theme:cart:change após mudanças no carrinho
      document.addEventListener("theme:cart:change", rebind, true);

      // UpCart às vezes muda DOM sem evento -> observa e rebind com debounce
      try {
        const mo = new MutationObserver(rebind);
        mo.observe(document.body, { subtree: true, childList: true, attributes: true });
      } catch (_) {}
    }


  
  // ✅ Restaura pointer-events do carrinho caso alguma versão anterior tenha setado "none" por engano
  function restoreCartUiPointerEvents() {
    try {
      // não deixa o drawer do carrinho ficar "morto"
      document.querySelectorAll(CART_UI_SELECTOR).forEach((el) => {
        try {
          if (!el || !el.style) return;
          if (el.style.pointerEvents === "none") el.style.pointerEvents = "";
        } catch (_) {}
      });

      // overlays: só desbloqueia quando estiverem visíveis (evita fechar/abrir quebrar)
      const overlays = document.querySelectorAll('.drawer__overlay,.cart-drawer__overlay,.drawer-overlay,.overlay,.modal-overlay,[data-overlay],[data-cart-overlay]');
      overlays.forEach((el) => {
        try {
          if (!el || !el.style) return;
          if (el.style.pointerEvents !== "none") return;

          const c = getComputedStyle(el);
          const hidden = (c.display === "none" || c.visibility === "hidden" || Number(c.opacity) === 0 || el.getAttribute("aria-hidden") === "true");
          if (!hidden) el.style.pointerEvents = "";
        } catch (_) {}
      });
    } catch (_) {}
  }

// ✅ Desbloqueia o CTA se algum overlay "fantasma" do carrinho ficar por cima após fechar o drawer
  function unblockCtaInteraction() {
    try {
      // Se o carrinho estiver realmente aberto/visível, não mexe (senão quebra checkout/remoção).
      try {
        if ((typeof cartDrawerLooksOpen === "function" && cartDrawerLooksOpen()) || __fozoco_isCartUiVisible()) return;
      } catch (_) {}

      // 1) Remove overlays invisíveis que ficam por cima da página (CTA "morto")
      try { neutralizeInvisibleOverlays(); } catch (_) {}

      // 2) Se o tema ficou com lock de drawer mas sem drawer visível (estado travado), destrava
      try {
        const body = document.body;
        const html = document.documentElement;
        const hasLock =
          (body && body.classList && (body.classList.contains("drawer-open") || body.classList.contains("js-drawer-open") || body.classList.contains("js-drawer-open-right") || body.classList.contains("cart-drawer-open") || body.classList.contains("js-cart-open") || body.classList.contains("modal-open") || body.classList.contains("no-scroll") || body.classList.contains("scroll-locked") || body.classList.contains("overflow-hidden") || body.classList.contains("lock-scroll") || body.classList.contains("is-locked"))) ||
          (html && html.classList && (html.classList.contains("drawer-open") || html.classList.contains("js-drawer-open") || html.classList.contains("js-drawer-open-right") || html.classList.contains("modal-open") || html.classList.contains("no-scroll") || html.classList.contains("scroll-locked") || html.classList.contains("overflow-hidden") || html.classList.contains("lock-scroll") || html.classList.contains("is-locked")));

        if (hasLock) {
          try { hardResetThemeDrawerLocks(); } catch (_) {}
          try { document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: true })); } catch (_) {}
          try { document.body && (document.body.style.overflow = ""); } catch (_) {}
          try { document.documentElement && (document.documentElement.style.overflow = ""); } catch (_) {}
        }
      } catch (_) {}

      // 3) Garante que CTAs não fiquem desabilitados
      try { ensureCtasEnabled(); } catch (_) {}
      try { restoreCartUiPointerEvents(); } catch (_) {}
    } catch (_) {}
  }

    // ✅ Fallback: after reload, some themes don't open the cart drawer on icon click.
  // We don't prevent default; we only call openUpCart() if nothing opened shortly after the click.

  // ✅ Observa abertura/fechamento do carrinho (qualquer forma de fechar: overlay, ESC, etc.)
  // Quando detectar transição ABERTO -> FECHADO, remove overlays invisíveis e destrava CTAs.
  function startCartOpenCloseWatcher() {
    try {
      if (window.__fozoco_cart_open_close_watch) return;
      window.__fozoco_cart_open_close_watch = true;

      let wasOpen = false;
      let t = null;

      const isOpenNow = () => {
        try {
          if (typeof cartDrawerLooksOpen === "function" && cartDrawerLooksOpen()) return true;
        } catch (_) {}
        try {
          if (typeof __fozoco_isCartUiVisible === "function" && __fozoco_isCartUiVisible()) return true;
        } catch (_) {}
        return false;
      };

      const check = () => {
        try {
          const now = isOpenNow();
          if (wasOpen && !now) {
            // acabou de fechar: limpa overlays/locks que podem matar o CTA
            setTimeout(() => { try { unblockCtaInteraction(); } catch (_) {} }, 120);
            setTimeout(() => { try { unblockCtaInteraction(); } catch (_) {} }, 800);
          }
          wasOpen = now;
        } catch (_) {}
      };

      const schedule = () => {
        try {
          if (t) clearTimeout(t);
          t = setTimeout(check, 60);
        } catch (_) {}
      };

      try {
        const obs = new MutationObserver(schedule);
        if (document.body) obs.observe(document.body, { attributes: true, attributeFilter: ["class", "style"] });
        if (document.documentElement) obs.observe(document.documentElement, { attributes: true, attributeFilter: ["class", "style"] });
      } catch (_) {}

      // ESC costuma fechar drawers
      try {
        window.addEventListener("keyup", (e) => {
          try {
            if (e && (e.key === "Escape" || e.key === "Esc")) setTimeout(check, 80);
          } catch (_) {}
        }, true);
      } catch (_) {}

      // Eventos (se o tema/app emitir)
      try {
        ["theme:cart:close", "cart:close", "ajaxCart:close"].forEach((ev) => {
          document.addEventListener(ev, () => setTimeout(check, 60), true);
        });
      } catch (_) {}

      // primeira checagem
      setTimeout(check, 120);
    } catch (_) {}
  }

  function __fozoco_isCartUiVisible() {
    try {
      const els = document.querySelectorAll(CART_UI_SELECTOR);
      const isVisibleOnScreen = (el) => {
        try {
          if (!el) return false;

          // Se o match cair no <body>/<html> por causa de classe global, ignora.
          if (el === document.body || el === document.documentElement) return false;

          const r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          if (!r || r.width < 8 || r.height < 8) return false;

          const cs = getComputedStyle(el);
          if (cs.display === "none" || cs.visibility === "hidden") return false;
          const op = parseFloat(cs.opacity || "1");
          if (Number.isFinite(op) && op <= 0.12) return false;

          const offscreen = r.right <= 0 || r.bottom <= 0 || r.left >= window.innerWidth || r.top >= window.innerHeight;
          if (offscreen) return false;

          return true;
        } catch (_) {
          return false;
        }
      };

      for (const el of els) {
        if (isVisibleOnScreen(el)) return true;
      }
    } catch (_) {}
    return false;
  }

  function installCartIconFallback() {
    if (window.__fozoco_cart_icon_fallback) return;
    window.__fozoco_cart_icon_fallback = true;

    const CART_ICON_SELECTOR = [
      'a[href="/cart"]',
      'a[href^="/cart?"]',
      'a[href*="/cart"]',
      '[data-cart-toggle]',
      '[data-drawer-toggle="cart"]',
      '[data-drawer-trigger="cart"]',
      '[aria-controls*="Cart"]',
      '[aria-controls*="cart"]',
      '.header__icon--cart',
      '.site-nav__link--cart',
      '.cart-link',
      '.js-drawer-open-cart',
      '.cart-toggle'
    ].join(",");

    const pickCartIcon = () => {
      try {
        const list = Array.from(document.querySelectorAll(CART_ICON_SELECTOR));
        for (const el of list) {
          if (!el) continue;
          const r = el.getBoundingClientRect ? el.getBoundingClientRect() : null;
          if (!r || r.width < 8 || r.height < 8) continue;
          const cs = getComputedStyle(el);
          if (cs.display === "none" || cs.visibility === "hidden") continue;
          const op = parseFloat(cs.opacity || "1");
          if (Number.isFinite(op) && op <= 0.12) continue;
          // Cursor padrão de link/ícone clicável
          try { el.style.cursor = "pointer"; } catch (_) {}
          return el;
        }
      } catch (_) {}
      return null;
    };

    // Rescue: se um overlay fantasma estiver por cima do ícone do carrinho, ainda assim abrir.
    const rescuePointer = (e) => {
      try {
        const icon = pickCartIcon();
        if (!icon) return;
        const r = icon.getBoundingClientRect();
        const x = e.clientX, y = e.clientY;
        if (!Number.isFinite(x) || !Number.isFinite(y)) return;
        if (x < r.left || x > r.right || y < r.top || y > r.bottom) return;

        // Se o clique NÃO caiu no ícone (overlay por cima), abre pelo fallback.
        const topEl = document.elementFromPoint(x, y);
        if (topEl && (topEl === icon || (icon.contains && icon.contains(topEl)))) return;

        // Não mexe se o carrinho já estiver visível
        if (__fozoco_isCartUiVisible()) return;

        try { openUpCart({ force: true }); } catch (_) {}
      } catch (_) {}
    };

    window.addEventListener("pointerdown", rescuePointer, true);

    // Fallback normal: se clicou no ícone e o tema não abriu, abre a gente.
    document.addEventListener("click", (e) => {
      try {
        const trg = e.target && e.target.closest ? e.target.closest(CART_ICON_SELECTOR) : null;
        if (!trg) return;

        // Evita navegar para /cart caso o tema falhe em interceptar (queremos drawer)
        try {
          const isCartPage = /^\/cart(\/|$)/.test(window.location.pathname || "");
          const isMod = e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey;
          if (!isCartPage && !isMod && trg && trg.tagName === "A") {
            const href = (trg.getAttribute("href") || "").toLowerCase();
            const blank = (trg.getAttribute("target") || "").toLowerCase() === "_blank";
            if (!blank && href && href.indexOf("/cart") === 0) {
              e.preventDefault();
            }
          }
        } catch (_) {}

        // ignore clicks from inside cart UI (close buttons etc)
        try { if (isInCartUi(trg)) return; } catch (_) {}

        setTimeout(() => {
          try {
            if (!__fozoco_isCartUiVisible()) openUpCart();
              // último fallback: tenta destravar e reabrir (sem navegar)
              try {
                setTimeout(() => {
                  try {
                    if (!__fozoco_isCartUiVisible()) {
                      try { hardResetThemeDrawerLocks(); } catch (_) {}
                      try { restoreCartUiPointerEvents(); } catch (_) {}
                      try { openUpCart({ force: true }); } catch (_) {}
                    }
                  } catch (_) {}
                }, 650);
              } catch (_) {}
          } catch (_) {}
        }, 180);
      } catch (_) {}
    }, true);
  }

  onReady(installCartIconFallback);

  window.addEventListener("pageshow", installCartIconFallback);

  function installCtaClickRescue() {
  if (window.__fozoco_capture_lentes_cta) return;
  window.__fozoco_capture_lentes_cta = true;

  const inCartArea = (el) => {
    try {
      return !!el.closest('#CartDrawer, .cart-drawer, cart-drawer, .drawer--cart, [data-drawer="cart"], [data-cart-drawer], upcart-drawer, upcart-cart, .upcart__drawer, .upcart__cart, #upcart, #upcart-root, [data-upcart]');
    } catch (_) { return false; }
  };

  const rescue = async (e) => {
    const target = e.target && e.target.closest ? e.target : null;
    if (!target) return;

    // pega SEMPRE o botão atual do form /cart/add (mesmo se o tema recriar)
    const btn = target.closest('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] input[type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!btn) return;

    // não intercepta dentro do carrinho/drawer
    if (inCartArea(btn)) return;

    // só em produtos com tag (se você já tem productHasTag no arquivo)
    try {
      if (typeof productHasTag === "function") {
        const ok = await productHasTag("HABILITA_LENTES");
        if (!ok) return;
      }
    } catch (_) {}

    try { e.preventDefault(); } catch (_) {}
    try { e.stopPropagation(); } catch (_) {}
    try { if (e.stopImmediatePropagation) e.stopImmediatePropagation(); } catch (_) {}

    // destrava estado visual caso tema deixe disabled/loading
    try {
      btn.disabled = false;
      btn.removeAttribute("disabled");
      btn.removeAttribute("aria-disabled");
      btn.classList.remove("is-loading","loading","disabled","is-disabled","btn--loading","button--loading");
    } catch (_) {}

    // abre teu drawer de lentes
    try { openDrawer(); } catch (_) {}
  };

  window.addEventListener("pointerdown", rescue, true);
  window.addEventListener("click", rescue, true);
}



  
  function startCtaRebindWatch() {
    if (window.__fozoco_cta_rebind_watch) return;
    window.__fozoco_cta_rebind_watch = true;

    let t = null;
    const schedule = () => {
      clearTimeout(t);
      t = setTimeout(() => {
        try { setupCTA(); } catch (_) {}
        try { fixProductQtyButtons(); } catch (_) {}
        try { ensureCtasEnabled(); } catch (_) {}
      }, 220);
    };

    // Eventos comuns do Pipeline/Shopify
    try { document.addEventListener("theme:cart:change", schedule, true); } catch (_) {}
    try { document.addEventListener("theme:cart:open", schedule, true); } catch (_) {}
    try { document.addEventListener("cart:open", schedule, true); } catch (_) {}
    try { document.addEventListener("ajaxCart:open", schedule, true); } catch (_) {}
    try { document.addEventListener("theme:variant:change", schedule, true); } catch (_) {}
    try { document.addEventListener("shopify:section:load", schedule); } catch (_) {}

    // Fallback leve: observa só o FORM principal (sem observar "class/style" no body inteiro)
    try {
      const form = (typeof getMainProductForm === "function") ? getMainProductForm() : null;
      if (form) {
        const obs = new MutationObserver(() => schedule());
        obs.observe(form, { subtree: true, childList: true });
      }
    } catch (_) {}

    schedule();
  }


// Mantém o FIX dos botões de quantidade (-/+) ativo no site inteiro (mesmo em produtos sem lentes)
// Isso evita que o tema trate -/+ como "submit" dentro do <form> e acabe adicionando ao carrinho.
function startQtyFixWatch() {
  if (window.__fozoco_qty_fix_watch) return;
  window.__fozoco_qty_fix_watch = true;

  // Só faz sentido em página de produto (evita custo no site inteiro)
  const isProduct =
    /\/products\//.test(window.location.pathname || "") ||
    (document.body && document.body.classList && (document.body.classList.contains("template-product") || document.body.classList.contains("template-product__main")));

  if (!isProduct) return;

  let t = null;
  const schedule = () => {
    clearTimeout(t);
    t = setTimeout(() => {
      try { fixProductQtyButtons(); } catch (_) {}
    }, 240);
  };

  // Eventos comuns do Pipeline/Shopify
  try { document.addEventListener("theme:variant:change", schedule, true); } catch (_) {}
  try { document.addEventListener("shopify:section:load", schedule); } catch (_) {}

  // Fallback leve: observa só o FORM principal
  try {
    const form = (typeof getMainProductForm === "function") ? getMainProductForm() : null;
    if (form) {
      const obs = new MutationObserver(() => schedule());
      obs.observe(form, { subtree: true, childList: true });
    }
  } catch (_) {}

  schedule();
}



// ✅ Após o reload do produto (quando adiciona óculos + lente), abre o drawer automaticamente
function tryAutoOpenCartAfterReload() {
  try {
    const flag = sessionStorage.getItem("__fozoco_open_cart_after_reload");
    if (!flag) return;

    const ts = parseInt(sessionStorage.getItem("__fozoco_open_cart_after_reload_ts") || "0", 10);

    // consome a flag (evita abrir em outras páginas)
    sessionStorage.removeItem("__fozoco_open_cart_after_reload");
    sessionStorage.removeItem("__fozoco_open_cart_after_reload_ts");

    // expira em 2 minutos
    if (ts && Date.now() - ts > 2 * 60 * 1000) return;

    const go = () => {
      try { neutralizeInvisibleOverlays(); } catch (_) {}
      try { openUpCart({ force: true }); } catch (_) {}
    };

    // dá tempo para o tema/app (UpCart) montar o drawer após o reload
    [120, 350, 800, 1400, 2200, 3200, 4500, 6500].forEach((d) => setTimeout(go, d));
  } catch (_) {}
}



onReady(async () => {
  // ✅ mantém esse fix sempre (é “genérico” de página de produto)
  try { fixProductQtyButtons(); } catch (_) {}
  try { startQtyFixWatch(); } catch (_) {}

  const has = await productHasTag(TAG_HABILITA);
  if (!has) return; // 👈 NÃO é produto com lentes? não mexe em mais nada.

  __fozocoLentesEnabled = true; // libera setupCTA() a partir daqui

  // Só produtos com HABILITA_LENTES
  startCartUiObserver();
  try { startCartOpenCloseWatcher(); } catch (_) {}
  // try { tryAutoOpenCartAfterReload(); } catch (_) {} // (se já desativou, pode ficar fora)
  setupBundleAutoRemove();

  setupCTA();
  ensureCtasEnabled();
  installCtaClickRescue();
  startCtaRebindWatch();

  try { applyCtaStockState(); } catch (_) {}
  try { loadVariantAvailability().then(() => { try { applyCtaStockState(); } catch (_) {} }); } catch (_) {}
});

})();






/* FOZOCO — FIX DEFINITIVO: URL gigante de receita no drawer (tema + UpCart/shadow) */
(() => {
  const MODE = "label"; // "label" = mostra "Ver receita" | "clamp" = mantém URL mas limita
  const LABEL = "Ver receita";
  const STYLE_ID = "fozoco-fix-receita-url";

  const isUploadUrl = (s) => {
    const t = String(s || "");
    return (
      t.includes("/uploads/") ||
      t.includes("cdn.shopify.com") ||
      t.includes("shopify.com/s/files") ||
      t.includes("/s/files/")
    );
  };

  const toHref = (raw) => {
    const u = String(raw || "").trim();
    if (!u) return "";
    if (u.startsWith("http://") || u.startsWith("https://")) return u;
    if (u.startsWith("//")) return "https:" + u;
    if (u.startsWith("/")) return window.location.origin + u;
    return "https://" + u;
  };

  const CSS = `
    /* segura overflow horizontal do drawer */
    .fozoco-no-x { overflow-x: hidden !important; }

    /* link curtinho e sempre “quebrável” */
    .fozoco-receita-link{
      display:inline-block !important;
      max-width:100% !important;
      overflow-wrap:anywhere !important;
      word-break:break-word !important;
      white-space:normal !important;
      line-height:1.2 !important;
      min-width:0 !important;
      text-decoration: underline !important;
    }

    /* se você trocar MODE pra clamp */
    .fozoco-receita-clamp{
      display:-webkit-box !important;
      -webkit-box-orient:vertical !important;
      -webkit-line-clamp:2 !important;
      overflow:hidden !important;
    }
  `;

  function ensureStyle(root) {
    try {
      const doc = root?.ownerDocument || document;
      const head = doc.head || doc.documentElement;
      if (head.querySelector(`#${STYLE_ID}`)) return;

      const st = doc.createElement("style");
      st.id = STYLE_ID;
      st.textContent = CSS;
      head.appendChild(st);
    } catch (_) {}
  }

  function fixAnchors(root) {
    root.querySelectorAll?.("a").forEach((a) => {
      if (a.getAttribute("data-fozoco-receita") === "1") return;

      const href = a.getAttribute("href") || "";
      const txt = (a.textContent || "").trim();
      if (!isUploadUrl(href) && !isUploadUrl(txt)) return;

      a.classList.add("fozoco-receita-link");
      if (MODE === "clamp") a.classList.add("fozoco-receita-clamp");
      if (MODE === "label") a.textContent = LABEL;

      a.setAttribute("data-fozoco-receita", "1");
      a.title = a.href || href;
      try {
        a.target = "_blank";
        a.rel = "noopener";
      } catch (_) {}
    });
  }

  function fixTextUrls(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const t = (node.nodeValue || "").trim();
          if (!t) return NodeFilter.FILTER_REJECT;
          if (!isUploadUrl(t)) return NodeFilter.FILTER_REJECT;
          // não mexe se já foi tratado
          if (node.parentElement?.closest?.('[data-fozoco-receita="1"]')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((textNode) => {
      const raw = (textNode.nodeValue || "").trim();
      if (!isUploadUrl(raw)) return;

      // tenta extrair “a parte do URL” se tiver texto junto
      const parts = raw.split(/\s+/);
      const urlPart = parts.find(isUploadUrl) || raw;
      const href = toHref(urlPart);

      const a = document.createElement("a");
      a.href = href;
      a.className = "fozoco-receita-link" + (MODE === "clamp" ? " fozoco-receita-clamp" : "");
      a.textContent = MODE === "label" ? LABEL : raw;
      a.title = href;
      a.setAttribute("data-fozoco-receita", "1");
      a.target = "_blank";
      a.rel = "noopener";

      // substitui só o nó de texto (mínimo risco)
      textNode.parentNode?.replaceChild(a, textNode);
    });
  }

  function fixRoot(root) {
    try {
      if (!root) return;
      ensureStyle(root);

      // evita “espaço lateral” se algum texto estourar
      try { root.classList?.add("fozoco-no-x"); } catch (_) {}
      try { if (root.style) root.style.overflowX = "hidden"; } catch (_) {}

      fixAnchors(root);
      fixTextUrls(root);
    } catch (_) {}
  }

  function getCartLikeRoots() {
    const roots = new Set();

    // drawers comuns (tema)
    [
      "#CartDrawer",
      ".drawer--cart",
      ".cart-drawer",
      "[data-cart-drawer]",
      "[data-drawer='cart']",
      "[data-drawer-id='cart']",
      ".ajax-cart__drawer",
    ].forEach((sel) => document.querySelectorAll(sel).forEach((el) => roots.add(el)));

    // UpCart: pega QUALQUER elemento cujo tag tenha "upcart"
    document.querySelectorAll("*").forEach((el) => {
      const tn = (el.tagName || "").toLowerCase();
      if (tn.includes("upcart")) roots.add(el);
      const idc = (el.id || "") + " " + (el.className || "");
      if (idc.toLowerCase().includes("upcart")) roots.add(el);
    });

    return Array.from(roots);
  }

  function observe(root) {
    try {
      // roda já
      fixRoot(root);

      const obs = new MutationObserver(() => fixRoot(root));
      obs.observe(root, { childList: true, subtree: true });
    } catch (_) {}
  }

  function init() {
    const roots = getCartLikeRoots();
    if (!roots.length) return false;

    roots.forEach((host) => {
      observe(host);

      // se tiver shadowRoot aberto (UpCart), observa lá dentro também
      try {
        if (host.shadowRoot) observe(host.shadowRoot);
      } catch (_) {}
    });

    return true;
  }

  // tenta algumas vezes (sem travar)
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    if (init() || tries >= 30) clearInterval(timer);
  }, 250);

  // se o tema disparar evento de carrinho, tenta de novo
  document.addEventListener("theme:cart:change", () => init(), true);
  document.addEventListener("theme:cart:init", () => init(), true);
})();





/*******************************************************
 * FOZOCO – LENTES + ÓCULOS
 * Versão: v8.1 – checkout-orphan-fix
 * Ajustes:
 * 1) Se a lente for removida e o usuário clicar em checkout,
 *    o checkout prossegue apenas com o óculos (remove órfãos antes).
 * 2) Garante que a limpeza acontece antes do redirect.
 * 3) Não interfere quando não há bundle.
 *******************************************************/

(function () {
  "use strict";

  // ========= Helpers =========
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(sel)
    );
  }

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }, opts || {})).then(function (r) { return r.json(); });
  }

  // ========= Bundle helpers =========
  function getBundleKey(item) {
    return (
      (item.properties && (item.properties._fozoco_bundle_id || item.properties.fozoco_bundle_id)) ||
      null
    );
  }

  function getBundleRole(item) {
    return (
      (item.properties && (item.properties._fozoco_bundle_role || item.properties.fozoco_bundle_role)) ||
      null
    );
  }

  function removeLineItem(key) {
    return fetchJSON("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  /**
   * Remove lentes órfãs quando o óculos do mesmo bundle não existe
   * Retorna Promise que resolve quando terminar
   */
  function cleanupOrphanLenses() {
    return fetchJSON("/cart.js").then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;

      var bundles = {};
      cart.items.forEach(function (item) {
        var bid = getBundleKey(item);
        if (!bid) return;
        bundles[bid] = bundles[bid] || { glasses: [], lens: [] };
        var role = getBundleRole(item);
        if (role === "glasses") bundles[bid].glasses.push(item);
        if (role === "lens") bundles[bid].lens.push(item);
      });

      var removals = [];
      Object.keys(bundles).forEach(function (bid) {
        var b = bundles[bid];
        // Se não tem óculos mas tem lente → remove lente
        if (!b.glasses.length && b.lens.length) {
          b.lens.forEach(function (l) {
            removals.push(removeLineItem(l.key));
          });
        }
      });

      if (!removals.length) return;
      return Promise.all(removals);
    });
  }

  // ========= Checkout interception =========
  function interceptCheckout() {
    var checkoutSelectors = [
      'a[href*="/checkout"]',
      'button[name="checkout"]',
      'form[action="/checkout"] button',
      '[data-checkout]'
    ];

    qsa(checkoutSelectors.join(",")).forEach(function (el) {
      if (el.__fozoco_bound) return;
      el.__fozoco_bound = true;

      el.addEventListener("click", function (e) {
        if (e.metaKey || e.ctrlKey) return;
        e.preventDefault();

        cleanupOrphanLenses()
          .catch(function () {})
          .finally(function () {
            window.location.href = "/checkout";
          });
      });
    });
  }

  // ========= Init =========
  document.addEventListener("DOMContentLoaded", function () {
    interceptCheckout();

    // Reinstala caso o drawer re-renderize
    var mo = new MutationObserver(function () {
      interceptCheckout();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  });





  /* Removido: exports de debug (window.FOZOCO_LENTES.openDrawer/.setupCTA).
     Estas linhas ficam DENTRO da IIFE do checkout-orphan, mas openDrawer e
     setupCTA sao definidos na IIFE do drawer de lentes, que fecha na linha
     ~3395. O resultado era "ReferenceError: openDrawer is not defined", que
     abortava o restante do script — inclusive o handler "last resort" logo
     abaixo, que reprende o CTA quando o tema recria o botao. */

/* Removido: handler "last resort" de captura global do CTA.

   Ele prendia QUALQUER botao de /cart/add que casasse com
   `.product-form__submit, button[name="add"], input[name="add"]` e chamava
   openDrawer() — sem nenhuma checagem da tag HABILITA_LENTES. Na pratica isso
   abria o fluxo de grau em oculos de sol, permitindo pedir lente de grau para
   produto que nao tem lente.

   Ele nunca chegou a rodar em producao: o ReferenceError das linhas de debug
   logo acima abortava o script antes daqui. Ao corrigir aquele erro este bloco
   "acordou" e o bug apareceu. Alem disso openDrawer e isInCartUi nem estao no
   escopo desta IIFE, entao ele nao teria como funcionar corretamente aqui.

   O gate correto ja existe e continua ativo: onReady() -> productHasTag(
   TAG_HABILITA) -> setupCTA(), que so prende o CTA em produtos com a tag. */



})();



})();
